import { C } from "./re-colors.ts";

// ── BANK METADATA ─────────────────────────────────────────────────
export const TEST_DATA = {
  meta: {
    asOfDate: "March 2, 2026",
    institution: "Demo Regional Bank",
    rssd: "3421887",
    ein: "94-3821044",
    charter: "State Member Bank",
    fdic_cert: "58841",
    dataSource: "FIS Horizon Core · FDIC Call Report · FRB Y-9C",
  },
  institution: {
    name: "Demo Regional Bank",
    assets: 4210000000,
    assetsFmt: "$4.21B",
    branches: 18,
    employees: 312,
    location: "Metro City, [State]",
    tier1Capital: 0.128,
    totalCapital: 0.139,
    cet1: 0.128,
    leverage: 0.102,
  },
  incomeStatement: {
    netInterestIncome: 38400000,
    nonInterestIncome: 6200000,
    totalRevenue: 44600000,
    provisionCreditLosses: 2100000,
    nonInterestExpense: 25800000,
    preTaxIncome: 10500000,
    taxExpense: 2600000,
    netIncome: 7900000,
    ytdBudgetVariance: 0.062,
    efficiencyRatio: 0.583,
    nim: 0.0342,
    roaa: 0.0114,
    roae: 0.118,
  },
  balanceSheet: {
    totalAssets: 4210000000,
    loansHFI: 2872000000,
    investmentsAFS: 421000000,
    investmentsHTM: 191000000,
    cashDue: 184000000,
    boli: 38000000,
    premises: 52000000,
    oreo: 11000000,
    otherAssets: 101000000,
    totalDeposits: 3620000000,
    fhlbBorrowings: 180000000,
    fhlbCapacity: 520000000,
  },
  loanPortfolio: {
    totalLoans: 2872000000,
    creNonOwner: 1040000000,
    ci: 612000000,
    agricultural: 438000000,
    ownerOccCRE: 349000000,
    residential: 262000000,
    consumer: 155000000,
    creConcentrationRatio: 2.87,
    nplRatio: 0.0061,
    nplTotal: 17500000,
    nonAccrual: 9300000,
    ncoRatio: 0.0008,
    netChargeoffs: 1900000,
  },
  cecl: {
    totalACL: 40700000,
    aclToLoans: 0.0142,
    qFactors: 6500000,
    agDroughtQFactor: 1200000,
    peerMedianACL: 0.0131,
    segments: [
      { name: "CRE Non-Owner Occupied", loans: 1040000000, acl: 12500000, rate: 0.0120 },
      { name: "C&I",                    loans:  612000000, acl:  9200000, rate: 0.0150 },
      { name: "Agricultural",           loans:  438000000, acl:  9600000, rate: 0.0219 },
      { name: "Owner-Occupied CRE",     loans:  349000000, acl:  3800000, rate: 0.0109 },
      { name: "Residential",            loans:  262000000, acl:  2100000, rate: 0.0080 },
      { name: "Consumer",               loans:  155000000, acl:  3500000, rate: 0.0226 },
    ],
  },
  deposits: {
    total: 3620000000,
    nonIntDDA: 0.284,
    uninsuredEstimate: 1230000000,
    uninsuredPct: 0.341,
    intraFiCapacity: 300000000,
    topConcentrations: [
      { name: "Metro Motors Group",      type: "Auto Dealer",   balance: 284000000, pct: 0.078, uninsured: 261000000, risk: "critical" },
      { name: "Regional Ag Cooperative",type: "Ag Business",   balance: 218000000, pct: 0.060, uninsured: 182000000, risk: "critical" },
      { name: "Summit Holdings LLC",    type: "CRE Holdings",  balance: 166000000, pct: 0.046, uninsured: 143000000, risk: "high"     },
      { name: "County School District", type: "Govt / Muni",   balance:  92000000, pct: 0.025, uninsured:         0, risk: "medium"   },
      { name: "Regional Health System", type: "Healthcare",    balance:  78000000, pct: 0.022, uninsured:  54000000, risk: "medium"   },
    ],
  },
  alm: {
    nim: 0.0342,
    nimQoQChange: -0.0008,
    loanYield: 0.0584,
    costOfDeposits: 0.0194,
    rateSensitivity: [
      { scenario: "+200 bps", niiImpact:  8400000, pct:  0.138 },
      { scenario: "+100 bps", niiImpact:  4200000, pct:  0.069 },
      { scenario: "+50 bps",  niiImpact:  2100000, pct:  0.034 },
      { scenario: "Base",     niiImpact:        0, pct:  0     },
      { scenario: "-50 bps",  niiImpact: -3200000, pct: -0.051 },
      { scenario: "-100 bps", niiImpact: -6800000, pct: -0.112 },
      { scenario: "-200 bps", niiImpact:-14100000, pct: -0.231 },
    ],
  },
  bsaAml: {
    openSARs: 4,
    ctrsFiled: { feb: 23, ytd: 41, onTimePct: 1.0, avgDays: 2.1 },
    hrcReviewsOverdue: 14,
  },
  cra: {
    rating: "Outstanding",
    nextExam: "Q4 2026",
    lmiLendingPct: 0.184,
    lendingTestScore: 92,
    investmentTestScore: 96,
    serviceTestScore: 89,
    lmiGapTracts: [
      { tract: "2011.01", area: "SW Metro",              lmiPct: 78, loansYTD: 0, peers: 4 },
      { tract: "2014.03", area: "Downtown District",    lmiPct: 71, loansYTD: 0, peers: 3 },
      { tract: "2019.07", area: "W. Metro Industrial",  lmiPct: 64, loansYTD: 0, peers: 2 },
    ],
  },
  criticizedAssets: {
    total: 47300000,
    specialMention: 28100000,
    substandard: 16200000,
    doubtful: 3000000,
    credits: [
      { name: "Meridian Properties Group",type: "CRE",    bal: 6700000, cls: "Special Mention", risk: "Maturity Apr 16 · DSCR 1.11x ↓", due: "Immediate" },
      { name: "Summit Storage LLC",     type: "CRE",    bal:  890000, cls: "Doubtful",         risk: "Legal hold · Guarantor in bankruptcy", due: "Immediate" },
      { name: "Westbrook Trucking",     type: "C&I",    bal: 2100000, cls: "Substandard",      risk: "Covenant breach", due: "Mar 10" },
      { name: "Valley Ridge Growers",   type: "Ag LOC", bal: 1800000, cls: "Special Mention",  risk: "96% utilization · Revenue -18%", due: "Mar 15" },
      { name: "Riverside Retail Partners",type: "CRE",  bal: 4200000, cls: "Special Mention",  risk: "Anchor tenant vacancy · NOI -22%", due: "Mar 31" },
      { name: "Metro Auto Parts",       type: "C&I",    bal:  420000, cls: "Substandard",      risk: "In collections", due: "Mar 20" },
    ],
  },
  agricultural: {
    totalPortfolio: 438000000,
    droughtAffectedCount: 14,
    droughtAffectedBalance: 67000000,
    insuranceVerified: 9,
    credits: [
      { name: "Valley Ridge Growers",     bal: 1800000, crop: "Almonds",    ins: "Verified",     action: "LOC utilization concern"      },
      { name: "River County Farmland Trust",bal:8200000, crop: "Cotton",    ins: "Not Verified", action: "Request policy cert"          },
      { name: "Valley Orchards Group",    bal: 6400000, crop: "Pistachios", ins: "Verified",     action: "Borrowing base needed"        },
      { name: "Riverside Row Crops LLC",  bal: 4100000, crop: "Wheat",      ins: "Not Verified", action: "Request policy cert"          },
      { name: "Westside Dairy Partners",  bal: 5300000, crop: "Hay / Feed", ins: "Verified",     action: "Monitor pasture impact"       },
      { name: "Lakeside Vineyard Holdings",bal:9700000, crop: "Wine Grapes",ins: "Not Verified", action: "Request policy cert"          },
    ],
  },
  operations: {
    achExceptions: 7,
    achReturnRate: 0.024,
    wiresProcessed: 43,
    wiresTotalValue: 12400000,
    ofacHolds: 1,
    branchErrorRate: 0.0004,
    branchTransactions: 14218,
    clovisVaultDiscrepancy: 4200,
    regCCTrainingPct: 0.61,
  },
  sba: {
    pipelineValue: 42000000,
    estFeeIncome: 420000,
    preQualified: 7,
    peerVolumeVariance: -0.34,
    leads: [
      { name: "Apex Medical Group",      type: "7(a)",     amt: 800000, fee: 24000, status: "Pre-Qualified", banker: "J. Reed"  },
      { name: "Heritage Hardware & Supply",type:"7(a)",  amt:1200000, fee: 36000, status: "Pre-Qualified", banker: "M. Torres"},
      { name: "Premier Dental Group",  type: "504",      amt: 650000, fee: 13000, status: "Pre-Qualified", banker: "J. Reed"  },
      { name: "Summit Catering",       type: "7(a)",     amt: 380000, fee: 11400, status: "Pre-Qualified", banker: "M. Torres"},
      { name: "South Auto Detail",     type: "Microloan",amt: 240000, fee:  4800, status: "Pre-Qualified", banker: "K. Perry" },
    ],
  },
  crm: {
    relationships: [
      { name: "Summit Family Trust",     type: "Commercial RE", loan: 4200000, dep: 1820000, prods: 4, score: 82, action: "Rate renewal — Apr 30 maturity",          risk: "high"   },
      { name: "Meridian Properties Group",type:"CRE",          loan: 6700000, dep:  380000, prods: 2, score: 64, action: "Refinance discussion — 45 days",           risk: "high"   },
      { name: "Apex Medical Group",     type: "C&I",           loan: 3100000, dep: 2200000, prods: 5, score: 88, action: "Competitor inquiry — call this week",       risk: "medium" },
      { name: "Valley Ridge Growers",   type: "Ag LOC",        loan: 1800000, dep:  410000, prods: 3, score: 71, action: "Crop insurance verification",               risk: "high"   },
      { name: "Heritage Hardware & Supply",type:"SBA 7(a)",    loan:  920000, dep:  680000, prods: 4, score: 79, action: "Treasury management referral",              risk: "low"    },
      { name: "Premier Dental Group",   type: "504 SBA",       loan:  650000, dep:  290000, prods: 3, score: 85, action: "Equipment LOC cross-sell",                 risk: "low"    },
      { name: "Riverside Retail Partners",type:"CRE",          loan: 4200000, dep:  120000, prods: 2, score: 68, action: "Anchor tenant issue — monitor",             risk: "high"   },
    ],
    avgProductsHH: 3.8,
    atRiskRevenue: 218000,
    retentionRateYTD: 0.94,
  },
  training: [
    { module: "BSA Annual Training",       pct: 91,  deadline: "Apr 30, 2026", status: "On Track"  },
    { module: "Reg CC Hold Policy Update", pct: 41,  deadline: "Mar 9, 2026",  status: "At Risk"   },
    { module: "OFAC Sanctions Refresher",  pct: 100, deadline: "Completed",    status: "Complete"  },
    { module: "CRA Community Awareness",   pct: 88,  deadline: "Ongoing",      status: "On Track"  },
    { module: "Fair Lending (ECOA/CRA)",   pct: 76,  deadline: "Mar 31, 2026", status: "On Track"  },
    { module: "Cybersecurity Awareness",   pct: 82,  deadline: "Apr 1, 2026",  status: "On Track"  },
  ],
};

export const BANK = TEST_DATA.meta;

// PERSONAS are now defined after the new data exports below

// ── PEER BENCHMARK DATA ───────────────────────────────────────────
export const PEER_DATA = [
  { metric: "ROAA",               unit: "%", vfb:  1.14, p25:  0.82, p50:  1.08, p75:  1.31, format: (v: number) => `${v.toFixed(2)}%`, higher: true  },
  { metric: "ROAE",               unit: "%", vfb: 11.8,  p25:  8.9,  p50: 10.9,  p75: 13.2,  format: (v: number) => `${v.toFixed(1)}%`, higher: true  },
  { metric: "NIM",                unit: "%", vfb:  3.42, p25:  3.01, p50:  3.38, p75:  3.74,  format: (v: number) => `${v.toFixed(2)}%`, higher: true  },
  { metric: "Efficiency Ratio",   unit: "%", vfb: 58.3,  p25: 54.1,  p50: 56.1,  p75: 61.8,  format: (v: number) => `${v.toFixed(1)}%`, higher: false },
  { metric: "NPL Ratio",          unit: "%", vfb:  0.61, p25:  0.42, p50:  0.74, p75:  1.12,  format: (v: number) => `${v.toFixed(2)}%`, higher: false },
  { metric: "NCO Ratio",          unit: "%", vfb:  0.08, p25:  0.06, p50:  0.11, p75:  0.19,  format: (v: number) => `${v.toFixed(2)}%`, higher: false },
  { metric: "ACL / Loans",        unit: "%", vfb:  1.42, p25:  1.18, p50:  1.31, p75:  1.58,  format: (v: number) => `${v.toFixed(2)}%`, higher: false },
  { metric: "Tier 1 Capital",     unit: "%", vfb: 12.8,  p25: 10.9,  p50: 12.1,  p75: 13.8,  format: (v: number) => `${v.toFixed(1)}%`, higher: true  },
  { metric: "Loan / Deposit",     unit: "%", vfb: 79.3,  p25: 71.2,  p50: 76.8,  p75: 83.4,  format: (v: number) => `${v.toFixed(1)}%`, higher: true  },
  { metric: "Cost of Deposits",   unit: "%", vfb:  1.94, p25:  1.62, p50:  1.88, p75:  2.21,  format: (v: number) => `${v.toFixed(2)}%`, higher: false },
  { metric: "Uninsured Deposits", unit: "%", vfb: 34.1,  p25: 28.4,  p50: 33.2,  p75: 39.1,  format: (v: number) => `${v.toFixed(1)}%`, higher: false },
  { metric: "CRE Concentration",  unit: "%", vfb: 287,   p25: 198,   p50: 241,   p75: 298,    format: (v: number) => `${v.toFixed(0)}%`, higher: false },
];

// ── EXAM READINESS CATEGORIES ─────────────────────────────────────
export const EXAM_CATEGORIES = [
  {
    cat: "BSA / AML", score: 71, weight: 0.22, color: C.gold,
    items: [
      { label: "SAR timeliness",    score: 85,  ok: true  },
      { label: "CTR compliance",    score: 100, ok: true  },
      { label: "High-risk reviews", score: 30,  ok: false },
      { label: "OFAC screening",    score: 72,  ok: true  },
      { label: "Staff training",    score: 91,  ok: true  },
    ],
  },
  {
    cat: "Capital Adequacy", score: 96, weight: 0.18, color: C.forest,
    items: [
      { label: "Tier 1 ratio",         score: 98, ok: true },
      { label: "CET1 ratio",           score: 98, ok: true },
      { label: "Leverage ratio",        score: 92, ok: true },
      { label: "Capital plan current",  score: 95, ok: true },
    ],
  },
  {
    cat: "Credit Quality", score: 78, weight: 0.22, color: C.gold,
    items: [
      { label: "Criticized asset trend",  score: 64, ok: false },
      { label: "NPL ratio vs peers",      score: 92, ok: true  },
      { label: "CECL methodology",        score: 88, ok: true  },
      { label: "Annual review currency",  score: 68, ok: false },
      { label: "Ag drought monitoring",   score: 74, ok: true  },
    ],
  },
  {
    cat: "Liquidity", score: 82, weight: 0.18, color: C.forest,
    items: [
      { label: "Deposit concentration",   score: 62, ok: false },
      { label: "Uninsured deposit pct",   score: 68, ok: false },
      { label: "FHLB capacity",           score: 95, ok: true  },
      { label: "Contingency funding plan",score: 90, ok: true  },
    ],
  },
  {
    cat: "CRA", score: 94, weight: 0.10, color: C.forest,
    items: [
      { label: "Overall rating",  score: 100, ok: true  },
      { label: "LMI lending",     score: 92,  ok: true  },
      { label: "LMI tract gaps",  score: 72,  ok: false },
      { label: "HMDA accuracy",   score: 74,  ok: false },
    ],
  },
  {
    cat: "IT / Operations", score: 84, weight: 0.10, color: C.forest,
    items: [
      { label: "ACH return rate",       score: 58, ok: false },
      { label: "Core system uptime",    score: 99, ok: true  },
      { label: "Cybersecurity training",score: 82, ok: true  },
      { label: "Change management",     score: 88, ok: true  },
    ],
  },
];

// ── BOOK OF BUSINESS ──────────────────────────────────────────────
export const BOOK_OF_BUSINESS = [
  {
    id: 1, name: "Summit Family Trust",    type: "Commercial RE", since: 2018, rm: "J. Reed",
    loan: 4200000, dep: 1820000, prods: ["CRE Term Loan","Business Checking","MMDA","Treasury Sweep"],
    score: 82, risk: "high",   ytdRevenue:  84200, annualRevenue: 122400,
    nextMaturity: "Apr 30, 2026", lastContact: "Feb 20, 2026",
    action: "Rate renewal — 59 days to maturity",
    nba:    "Offer 6.25% rate hold before competitor quotes",
    status: "Active", city: "Metro",   industry: "Real Estate", employees: 12,
    creditRating: "B+", dscr: 1.42, ltv: 0.61, collateral: "Commercial property — Metro City",
  },
  {
    id: 2, name: "Meridian Properties Group",type:"CRE",          since: 2020, rm: "J. Reed",
    loan: 6700000, dep:  380000, prods: ["CRE Term Loan","Business Checking"],
    score: 64, risk: "high",   ytdRevenue:  31400, annualRevenue:  98200,
    nextMaturity: "Apr 16, 2026", lastContact: "Feb 14, 2026",
    action: "Refinance discussion — DSCR 1.11x declining",
    nba:    "Initiate paydown discussion or seek guarantor support",
    status: "Watch",  city: "Metro",   industry: "Real Estate", employees: 4,
    creditRating: "C+", dscr: 1.11, ltv: 0.72, collateral: "Office complex — Meridian Street, Metro City",
  },
  {
    id: 3, name: "Apex Medical Group",     type: "C&I",           since: 2019, rm: "J. Reed",
    loan: 3100000, dep: 2200000, prods: ["C&I Term","Revolving LOC","Business Checking","MMDA","Merchant Services"],
    score: 88, risk: "medium", ytdRevenue:  42100, annualRevenue: 168000,
    nextMaturity: "Jan 15, 2027", lastContact: "Feb 24, 2026",
    action: "Competitor inquiry — credit pull Feb 24",
    nba:    "Call today with rate hold; highlight local decision authority",
    status: "Active", city: "Northside", industry: "Healthcare",  employees: 38,
    creditRating: "A-", dscr: 2.14, ltv: 0.48, collateral: "Medical equipment + receivables",
  },
  {
    id: 4, name: "Valley Ridge Growers",   type: "Ag LOC",        since: 2016, rm: "J. Reed",
    loan: 1800000, dep:  410000, prods: ["Ag LOC","Business Checking","Crop Insurance Escrow"],
    score: 71, risk: "high",   ytdRevenue:  18200, annualRevenue:  64800,
    nextMaturity: "Oct 1, 2026",  lastContact: "Feb 18, 2026",
    action: "Crop insurance verification due Mar 15",
    nba:    "Obtain updated crop insurance cert — downgrade risk if not received",
    status: "Watch",  city: "Southgate", industry: "Agriculture", employees: 22,
    creditRating: "B",  dscr: 1.28, ltv: 0.55, collateral: "Cropland — River County 480 acres",
  },
  {
    id: 5, name: "Heritage Hardware & Supply",type:"SBA 7(a)",    since: 2022, rm: "J. Reed",
    loan:  920000, dep:  680000, prods: ["SBA 7(a)","Business Checking","Business Visa","Merchant Services"],
    score: 79, risk: "low",    ytdRevenue:  16400, annualRevenue:  58800,
    nextMaturity: "Mar 1, 2029",  lastContact: "Feb 28, 2026",
    action: "Treasury management referral opportunity",
    nba:    "Introduce treasury management — $12K annual fee potential",
    status: "Active", city: "Metro",    industry: "Retail / Hardware", employees: 14,
    creditRating: "B+", dscr: 1.72, ltv: 0.38, collateral: "Business assets + personal guarantee",
  },
  {
    id: 6, name: "Premier Dental Group",   type: "504 SBA",       since: 2023, rm: "J. Reed",
    loan:  650000, dep:  290000, prods: ["SBA 504","Business Checking","Equipment LOC"],
    score: 85, risk: "low",    ytdRevenue:  11800, annualRevenue:  42400,
    nextMaturity: "Jun 1, 2030",  lastContact: "Mar 1, 2026",
    action: "Equipment LOC cross-sell — new chair purchase Q2",
    nba:    "Offer $150K equipment LOC; est. $4,200 annual fee income",
    status: "Active", city: "Northside", industry: "Healthcare",  employees: 9,
    creditRating: "A-", dscr: 2.08, ltv: 0.41, collateral: "Dental equipment + real estate",
  },
  {
    id: 7, name: "Riverside Retail Partners",type:"CRE",          since: 2021, rm: "J. Reed",
    loan: 4200000, dep:  120000, prods: ["CRE Term Loan","Business Checking"],
    score: 68, risk: "high",   ytdRevenue:  14200, annualRevenue:  62800,
    nextMaturity: "Dec 1, 2026",  lastContact: "Jan 30, 2026",
    action: "Anchor tenant vacancy — NOI -22%",
    nba:    "Request updated rent roll + 2025 operating statements immediately",
    status: "Watch",  city: "Southgate", industry: "Real Estate", employees: 3,
    creditRating: "C+", dscr: 1.09, ltv: 0.68, collateral: "Riverside retail strip — anchor tenant vacant",
  },
  {
    id: 8, name: "Eastview Family Medicine", type: "C&I",         since: 2024, rm: "J. Reed",
    loan:       0, dep:  142000, prods: ["Business Checking","MMDA"],
    score: 74, risk: "low",    ytdRevenue:   3200, annualRevenue:  12800,
    nextMaturity: null, lastContact: "Feb 10, 2026",
    action: "New prospect — SBA 7(a) pre-qualified for practice expansion",
    nba:    "Present SBA 7(a) for $480K expansion loan — est. $14.4K fee",
    status: "Prospect", city: "Eastview", industry: "Healthcare", employees: 11,
    creditRating: "N/A", dscr: null, ltv: null, collateral: "N/A",
  },
];

// ── MUTABLE AUDIT LOG (module-level, mutated in place) ────────────
export let _auditLog: any[] = [];

// ── TASK QUEUES ───────────────────────────────────────────────────
export let _tasks: Record<string, any[]> = {
  ceo: [
    { id: 1, title: "Review Q1 close package",                       priority: "high",     due: "Mar 7",  done: false, category: "Finance"    },
    { id: 2, title: "Board deck preparation",                         priority: "high",     due: "Mar 14", done: false, category: "Governance" },
    { id: 3, title: "SBA banker hire decision",                       priority: "medium",   due: "Mar 21", done: false, category: "Strategy"   },
    { id: 4, title: "Deposit concentration strategy — board approval",priority: "high",     due: "Apr 1",  done: false, category: "Risk"       },
  ],
  cfo: [
    { id: 1, title: "BOLI income accrual entry",           priority: "critical", due: "Mar 7",  done: false, category: "Close"    },
    { id: 2, title: "CECL Ag drought Q-factor approval",   priority: "critical", due: "Mar 7",  done: false, category: "Close"    },
    { id: 3, title: "Deferred loan fee recon",             priority: "critical", due: "Mar 7",  done: false, category: "Close"    },
    { id: 4, title: "FHLB advance term decision",          priority: "high",     due: "Mar 14", done: false, category: "ALM"      },
    { id: 5, title: "Efficiency ratio action plan",        priority: "medium",   due: "Mar 31", done: false, category: "Strategy" },
  ],
  banker: [
    { id: 1, title: "Call Summit Family Trust — maturity",        priority: "critical", due: "Today",  done: false, category: "Retention"     },
    { id: 2, title: "Apex Medical — competitor outreach",        priority: "high",     due: "Mar 4",  done: false, category: "Retention"     },
    { id: 3, title: "Valley Ridge Growers — insurance verify",   priority: "high",     due: "Mar 15", done: false, category: "Credit"        },
    { id: 4, title: "Heritage Hardware — SBA application",       priority: "medium",   due: "Mar 10", done: false, category: "New Business"  },
    { id: 5, title: "Eastview Dental — new prospect outreach",   priority: "medium",   due: "Mar 9",  done: false, category: "Prospects"     },
  ],
  ops: [
    { id: 1, title: "Resolve OFAC wire hold — Al Rashid",         priority: "critical", due: "Today",  done: false, category: "Compliance" },
    { id: 2, title: "ACH return rate — commercial portfolio review", priority: "critical", due: "Today",  done: false, category: "ACH"        },
    { id: 3, title: "North Branch vault dual-control reconciliation",priority:"high",    due: "Today",  done: false, category: "Branch"     },
    { id: 4, title: "Notify 18 branches — March 7 maintenance",   priority: "high",     due: "Mar 5",  done: false, category: "IT"         },
    { id: 5, title: "Reg CC teller training escalation",          priority: "high",     due: "Mar 7",  done: false, category: "Training"   },
  ],
  compliance: [
    { id: 1, title: "File SAR — Account #4471",                   priority: "critical", due: "Today",  done: false, category: "BSA"   },
    { id: 2, title: "OFAC secondary review — Al Rashid wire",     priority: "critical", due: "Today",  done: false, category: "OFAC"  },
    { id: 3, title: "HMDA LAR corrections — 6 exceptions",        priority: "high",     due: "Mar 15", done: false, category: "HMDA"  },
    { id: 4, title: "Assign 14 overdue BSA reviews",              priority: "high",     due: "Mar 31", done: false, category: "BSA"   },
    { id: 5, title: "CRA LMI tract outreach — CDFI partnership",  priority: "medium",   due: "Apr 15", done: false, category: "CRA"   },
  ],
  credit: [
    { id: 1, title: "Oaks Street — maturity discussion",           priority: "critical", due: "Today",  done: false, category: "Criticized"    },
    { id: 2, title: "Valley Ridge Growers — downgrade memo",        priority: "high",     due: "Mar 10", done: false, category: "Criticized"    },
    { id: 3, title: "Ag insurance verification — 5 borrowers",    priority: "high",     due: "Mar 15", done: false, category: "Agricultural"  },
    { id: 4, title: "CRE pipeline cap — ALCO policy memo",        priority: "high",     due: "Mar 14", done: false, category: "Concentration" },
    { id: 5, title: "Annual review queue — 17 credits",           priority: "medium",   due: "Mar 31", done: false, category: "Reviews"       },
  ],
  lending: [
    { id: 1, title: "LP-006 Westbrook Trucking — title search follow-up",   priority: "critical", due: "Today",  done: false, category: "Pipeline"    },
    { id: 2, title: "LP-004 Valley Orchards Group — committee prep",       priority: "high",     due: "Mar 4",  done: false, category: "Pipeline"    },
    { id: 3, title: "LP-003 Apex Medical — SBA CAIVRS clearance",         priority: "high",     due: "Mar 10", done: false, category: "SBA"         },
    { id: 4, title: "LP-001 Metro Commerce — Env. Phase 1 review",        priority: "high",     due: "Mar 15", done: false, category: "CRE"         },
    { id: 5, title: "Dealer channel RFP — 2 new auto dealers",            priority: "medium",   due: "Mar 21", done: false, category: "Strategy"    },
    { id: 6, title: "SBA pipeline review — $42M, 7 pre-qualified clients", priority: "medium",   due: "Mar 31", done: false, category: "SBA"         },
  ],
  cro: [
    { id: 1, title: "ALCO pre-meeting deck — March 14 board",               priority: "critical", due: "Mar 10", done: false, category: "ALCO"        },
    { id: 2, title: "Lock $100M FHLB advance before May FOMC window closes",priority: "critical", due: "Mar 14", done: false, category: "ALM"         },
    { id: 3, title: "AFS portfolio duration — review vs. policy limit 6yr", priority: "high",     due: "Mar 14", done: false, category: "Investment"  },
    { id: 4, title: "EVE sensitivity report — +/-200bps scenarios updated", priority: "high",     due: "Mar 21", done: false, category: "IRR"         },
    { id: 5, title: "LCR correlated-stress scenario — board disclosure",    priority: "medium",   due: "Mar 31", done: false, category: "Liquidity"   },
  ],
  mortgage: [
    { id: 1, title: "MG-007 Williams — suspended file, adverse action due", priority: "critical", due: "Today",  done: false, category: "Compliance"  },
    { id: 2, title: "MG-001 Rodriguez — UW conditions clear before lock exp",priority: "high",    due: "Mar 15", done: false, category: "Pipeline"    },
    { id: 3, title: "HMDA LAR corrections — Q1 submission March 31",        priority: "high",     due: "Mar 31", done: false, category: "HMDA"        },
    { id: 4, title: "FHA MIP rate change effective Apr 1 — pipeline notice", priority: "high",    due: "Mar 20", done: false, category: "Product"     },
    { id: 5, title: "Refi boom play — rate alert list outreach (82 on file)",priority: "medium",   due: "Mar 31", done: false, category: "Business Dev"},
  ],
  wealth: [
    { id: 1, title: "Regional Medical Pension — IPS equity breach remediation",priority:"critical", due: "Mar 7",  done: false, category: "Compliance"  },
    { id: 2, title: "Lakewood Trust — annual review overdue 12 days",         priority: "high",     due: "Mar 10", done: false, category: "Fiduciary"   },
    { id: 3, title: "County School Foundation — successor trustee appointment",priority:"high",     due: "Mar 31", done: false, category: "Legal"       },
    { id: 4, title: "Inland Ag Holdings — fee schedule correction billing",   priority: "medium",   due: "Mar 15", done: false, category: "Operations"  },
    { id: 5, title: "Q1 client performance letters — 142 accounts",          priority: "medium",   due: "Apr 7",  done: false, category: "Client Svc"  },
  ],
  branch: [
    { id: 1, title: "North Branch vault cam — follow up with IT on INC-2215", priority: "critical", due: "Today",  done: false, category: "Security"    },
    { id: 2, title: "West Branch — teller productivity action plan",          priority: "high",     due: "Mar 10", done: false, category: "Performance" },
    { id: 3, title: "Q1 deposit gathering goal — $40M short, plan needed",   priority: "high",     due: "Mar 14", done: false, category: "Deposits"    },
    { id: 4, title: "Reg CC teller training — 7 tellers not yet complete",   priority: "high",     due: "Mar 9",  done: false, category: "Training"    },
    { id: 5, title: "New DDA campaign — March goal 120 accounts",            priority: "medium",   due: "Mar 31", done: false, category: "Business Dev"},
  ],
};

// ── MORNING BRIEFINGS ─────────────────────────────────────────────
export const BRIEFINGS: Record<string, { greeting: string; summary: string; items: { icon: string; text: string; urgency: string }[] }> = {
  ceo: {
    greeting: "Good morning.",
    summary:  "4 high-priority items requiring attention. Net income tracking $7.9M, +6.2% vs budget.",
    items: [
      { icon: "🚨", text: "Deposit concentration board strategy — Metro Motors showing exit signals",                         urgency: "critical" },
      { icon: "📊", text: "SBA pipeline at $42M — 34% below peer median. Banker hiring decision needed",                    urgency: "high"     },
      { icon: "📉", text: "Fed cut pricing accelerating. FHLB advance lock window closes before May FOMC",                  urgency: "high"     },
      { icon: "✅", text: "Q1 earnings on track: $7.9M net income, ROAA 1.14% above peer median",                           urgency: "ok"       },
    ],
  },
  cfo: {
    greeting: "Good morning.",
    summary:  "Q1 close deadline is March 7 — 5 days away. Three items require direct approval today.",
    items: [
      { icon: "🚨", text: "BOLI accrual, CECL Ag Q-factor (+$1.2M), and deferred loan fee recon all pending approval",     urgency: "critical" },
      { icon: "📉", text: "NIM compressing -8bps QoQ. FHLB $100M 5-yr at 4.28% protects ~$420K NII",                      urgency: "high"     },
      { icon: "💧", text: "Uninsured deposits at 34.1% (+2.3% since Jan) — prepare for FDIC scrutiny",                     urgency: "high"     },
      { icon: "📊", text: "Budget variance +$110K net — fee income beats, personnel costs creeping",                        urgency: "ok"       },
    ],
  },
  banker: {
    greeting: "Good morning.",
    summary:  "3 high-priority client actions today. $218K at-risk revenue across 5 relationships.",
    items: [
      { icon: "🚨", text: "Call Summit Family Trust NOW — 59 days to maturity, rate renewal window closing",                urgency: "critical" },
      { icon: "🎯", text: "Competitor credit pull on Apex Medical — 48-hr retention window",                                urgency: "critical" },
      { icon: "🌾", text: "Valley Ridge Growers — crop insurance verification due March 15",                                urgency: "high"     },
      { icon: "🏘️", text: "3 new CA SOS filings this week match your SBA pipeline criteria",                               urgency: "ok"       },
    ],
  },
  ops: {
    greeting: "Good morning.",
    summary:  "2 critical items require immediate attention this morning.",
    items: [
      { icon: "🚨", text: "OFAC wire hold — Al Rashid Trading. 2-hour review window expires 10:42 AM",                     urgency: "critical" },
      { icon: "🔴", text: "ACH return rate at 2.4% vs 1.5% Nacha threshold — 7 exceptions pending",                        urgency: "critical" },
      { icon: "🔒", text: "North Branch vault overage $4,200 — dual control reconciliation required today",                 urgency: "high"     },
      { icon: "📚", text: "Reg CC training at 61% — 7 days to March 9 deadline",                                           urgency: "high"     },
    ],
  },
  compliance: {
    greeting: "Good morning.",
    summary:  "2 critical filings due today. SAR and OFAC review require immediate action.",
    items: [
      { icon: "🚨", text: "SAR filing due TODAY for Account #4471 — structuring pattern confirmed",                         urgency: "critical" },
      { icon: "🌍", text: "OFAC secondary review — Al Rashid Trading 94% SDN match, wire held",                            urgency: "critical" },
      { icon: "📋", text: "6 HMDA exceptions — LAR submission blocked until March 15",                                      urgency: "high"     },
      { icon: "🔍", text: "14 high-risk customer reviews overdue — FDIC exam prep risk",                                    urgency: "high"     },
    ],
  },
  credit: {
    greeting: "Good morning.",
    summary:  "Criticized assets at $47.3M and growing. Two credits require immediate action.",
    items: [
      { icon: "🚨", text: "Meridian Properties maturity April 16 — DSCR 1.11x, initiate workout discussion today",          urgency: "critical" },
      { icon: "📊", text: "Valley Ridge Growers: AI flags 84% probability of Substandard migration",                        urgency: "high"     },
      { icon: "🌾", text: "5 ag borrowers with unverified crop insurance — $31M unprotected drought exposure",             urgency: "high"     },
      { icon: "✅", text: "NPL ratio 0.61% vs peer median 0.74% — relative strength to highlight in exam prep",            urgency: "ok"       },
    ],
  },
  lending: {
    greeting: "Good morning.",
    summary:  "Pipeline at $14.1M across 8 opportunities. One approved deal stalled on title — close today.",
    items: [
      { icon: "🚨", text: "LP-006 Westbrook Trucking APPROVED — title search pending, close Mar 10 at risk",               urgency: "critical" },
      { icon: "📝", text: "LP-004 Valley Orchards Group — committee today, borrowing base needed before 2pm",               urgency: "critical" },
      { icon: "📊", text: "SBA pipeline $42M — 34% below peer median, 7 clients pre-qualified for fast close",             urgency: "high"     },
      { icon: "✅", text: "LP-002 Regional Medical Pre-Approval clean — no issues, target close Mar 28",                   urgency: "ok"       },
    ],
  },
  cro: {
    greeting: "Good morning.",
    summary:  "ALCO board deck due March 10. Rate lock window closing before May FOMC. AFS duration at policy limit.",
    items: [
      { icon: "🏛️", text: "FHLB $100M 5-yr lock: March 14 ALCO — rate at 4.28%, May cut would cost $420K/yr if missed",  urgency: "critical" },
      { icon: "📉", text: "AFS portfolio: $28.4M unrealized loss, duration 5.8yr — approaching 6yr policy limit",          urgency: "high"     },
      { icon: "💧", text: "LCR at 182% (base), but correlated-stress scenario drops to 88% — below 100% floor",            urgency: "high"     },
      { icon: "✅", text: "EVE sensitivity: +200bps scenario shows +$12.4M — liability-sensitive position hedge working",   urgency: "ok"       },
    ],
  },
  mortgage: {
    greeting: "Good morning.",
    summary:  "8 mortgages in pipeline, $3.9M. One suspended file requires adverse action today. 3 locks expire this month.",
    items: [
      { icon: "🚨", text: "MG-007 Williams suspended — ECOA adverse action letter due TODAY (day 30)",                     urgency: "critical" },
      { icon: "🔒", text: "MG-001 Rodriguez lock expires Mar 15 — UW conditions still open, 13 days left",                 urgency: "high"     },
      { icon: "📋", text: "HMDA Q1 LAR: 2 disposition fields need correction before March 31 submission",                  urgency: "high"     },
      { icon: "📈", text: "Rate drop 12bps last week — 82 borrowers on refi watch list; blast eligible contacts",           urgency: "ok"       },
    ],
  },
  wealth: {
    greeting: "Good morning.",
    summary:  "2 fiduciary compliance items require action today. $284M AUM stable with 4.2% QoQ growth.",
    items: [
      { icon: "🚨", text: "Regional Medical Pension equity at 48% vs 45% IPS limit — rebalance order needed today",        urgency: "critical" },
      { icon: "📋", text: "Garcia Testamentary Trust — annual review overdue 12 days, UPIA liability exposure",            urgency: "high"     },
      { icon: "⚖️", text: "County School Foundation — successor trustee vacant; court petition deadline April 30",       urgency: "high"     },
      { icon: "✅", text: "AUM grew 4.2% QoQ to $284M — fee income tracking $198K MTD, on pace for $2.84M annual",        urgency: "ok"       },
    ],
  },
  branch: {
    greeting: "Good morning.",
    summary:  "System-wide branches Q1 deposit goal $40M behind. West Branch underperforming. Vault cam issue requires IT followup.",
    items: [
      { icon: "🚨", text: "North Branch vault cam offline since Feb 23 — IT INC-2215 breached SLA, physical security gap",   urgency: "critical" },
      { icon: "📉", text: "Q1 deposit goal gap: $40M — West Branch at 91% of target, 28 days to quarter end",                urgency: "high"     },
      { icon: "📚", text: "Reg CC teller training: 7 tellers at your branch not yet certified — deadline March 9",           urgency: "high"     },
      { icon: "⭐", text: "Commerce Branch #1 in network: $814 revenue/teller, 94 health score — model to replicate",       urgency: "ok"       },
    ],
  },
};

// ── SUBBAR CONFIG ─────────────────────────────────────────────────
export const SUBBAR_CONFIG: Record<string, {
  label: string;
  status: { l: string; v: string }[];
  details: { icon: string; label: string; value: string }[];
}> = {
  ceo: {
    label:   "Executive Overview",
    status:  [{ l: "Board Mtg", v: "Mar 19" }, { l: "FDIC Exam", v: "May 2026" }, { l: "Earnings", v: "On Track" }],
    details: [
      { icon: "🏦", label: "Institution", value: "Demo Regional Bank · Metro City · State Member Bank" },
      { icon: "📊", label: "Assets",      value: "$4.21B · 18 branches · 312 employees"              },
      { icon: "🌱", label: "CRA Rating",  value: "Outstanding · Next exam Q4 2026"                   },
    ],
  },
  cfo: {
    label:   "Financial Operations",
    status:  [{ l: "Q1 Close", v: "Mar 7" }, { l: "Budget", v: "+6.2%" }, { l: "Capital", v: "Well-Cap" }],
    details: [
      { icon: "📋", label: "Reporting",    value: "FFIEC 031/041 · FRB Y-9C · FDIC Call Report"         },
      { icon: "🏦", label: "Charter",      value: "State Member Bank · EIN 94-3821044 · FDIC Cert #58841" },
      { icon: "⚙️", label: "Core Systems", value: "FIS Horizon Core · Bancware ALM · Workday HRIS"       },
    ],
  },
  banker: {
    label:   "Relationship Management",
    status:  [{ l: "Portfolio", v: "$47.3M" }, { l: "Retention", v: "94% YTD" }, { l: "Cross-Sell", v: "3.8 avg" }],
    details: [
      { icon: "🤝", label: "CRM System",    value: "Salesforce Financial Services Cloud"                    },
      { icon: "📂", label: "LOS",           value: "FIS Horizon · AFS Credit Platform · Sagent Servicing"  },
      { icon: "📊", label: "SBA Platform",  value: "SBA ETRAN · SBA CAIVRS · D&B Business Credit"          },
    ],
  },
  ops: {
    label:   "Operations & Payments",
    status:  [{ l: "ACH Rate", v: "2.4% ⚠" }, { l: "Uptime", v: "99.94%" }, { l: "Tickets", v: "18 open" }],
    details: [
      { icon: "⚙️", label: "Core",     value: "FIS Horizon Core · Jack Henry Symitar"               },
      { icon: "💳", label: "Payments", value: "Nacha ACH · FedACH · FedWire · SWIFT"                },
      { icon: "🏧", label: "Branch",   value: "FIS Branch Teller · Jack Henry Core · ServiceNow ITSM" },
    ],
  },
  compliance: {
    label:   "BSA / Compliance",
    status:  [{ l: "RSSD", v: "3421887" }, { l: "FDIC Cert", v: "58841" }, { l: "Exam Window", v: "May 2026" }],
    details: [
      { icon: "🛡️", label: "BSA/AML",         value: "Verafin · FinCEN BSA E-Filing · OFAC SDN List"            },
      { icon: "📋", label: "Regulatory IDs",   value: "RSSD 3421887 · EIN 94-3821044 · FDIC Cert #58841"         },
      { icon: "📑", label: "Reporting Feeds",  value: "FFIEC Call Report · FRB Reg H · FinCEN · HMDA LAR"        },
    ],
  },
  credit: {
    label:   "Credit & Risk",
    status:  [{ l: "NPL Ratio", v: "0.61%" }, { l: "CRE Conc.", v: "287%" }, { l: "ACL/Loans", v: "1.42%" }],
    details: [
      { icon: "📂", label: "Credit Systems", value: "AFS Credit Platform · Moody's Analytics · CoStar"          },
      { icon: "🌾", label: "Ag Data",        value: "USDA FSA · USDA RMA Crop Insurance · FCS AgriFinance"       },
      { icon: "📋", label: "Regulatory",     value: "FDIC ARIS · FFIEC Call Report RC-C · FASB ASC 326"          },
    ],
  },
  lending: {
    label:   "Loan Originations",
    status:  [{ l: "Pipeline", v: "$14.1M" }, { l: "SBA YTD", v: "$2.6M" }, { l: "Pull-Through", v: "76%" }],
    details: [
      { icon: "📝", label: "LOS",           value: "FIS Horizon LOS · SBA ETRAN · SBA CAIVRS · AFS Credit"      },
      { icon: "📊", label: "Origination",   value: "Encompass · HMDA Reporter · D&B Business Credit Insight"    },
      { icon: "🏛️", label: "Guaranty",     value: "SBA 7(a) / 504 · USDA B&I · CDFI Fund Certification"        },
    ],
  },
  cro: {
    label:   "Risk & ALCO",
    status:  [{ l: "LCR", v: "182%" }, { l: "EVE +200", v: "+$12.4M" }, { l: "AFS AOCI", v: "-$27.2M" }],
    details: [
      { icon: "📉", label: "ALM System",    value: "Bancware ALM · QRM · Bloomberg AFS Portfolio Analytics"          },
      { icon: "🏛️", label: "Funding",       value: "FHLB San Francisco · FRB Discount Window · IntraFi CDARS"        },
      { icon: "📋", label: "Regulatory",    value: "FDIC FIL-13-2023 · FRB SR 10-6 IRR Guidance · Basel III LCR"     },
    ],
  },
  mortgage: {
    label:   "Mortgage & Consumer",
    status:  [{ l: "Pipeline", v: "$3.9M" }, { l: "Lock Exp", v: "3 this month" }, { l: "HMDA", v: "2 errors" }],
    details: [
      { icon: "🏠", label: "LOS",           value: "Encompass by ICE · MISMO · MERS Registry"                         },
      { icon: "📊", label: "Secondary Mkt", value: "FNMA DU · FHLMC LP · FHA TOTAL Scorecard · VA LGY"                },
      { icon: "📋", label: "Compliance",    value: "HMDA Reg C · TRID · RESPA · Fair Lending ECOA/FHA"                },
    ],
  },
  wealth: {
    label:   "Wealth & Trust",
    status:  [{ l: "AUM", v: "$284M" }, { l: "Accounts", v: "142" }, { l: "Fee YTD", v: "$198K" }],
    details: [
      { icon: "💎", label: "Trust Systems", value: "SunGard Invest One · Orion Advisor · Tamarac CRM"                  },
      { icon: "⚖️", label: "Legal",         value: "CA Probate Code · UPIA · ERISA · UPIA Prudent Investor Rule"       },
      { icon: "📋", label: "Regulatory",    value: "OCC 12 CFR Part 9 · FDIC Trust Manual · FINRA"                    },
    ],
  },
  branch: {
    label:   "Branch Operations",
    status:  [{ l: "Deposits", v: "$684M" }, { l: "Rev/Teller", v: "$742" }, { l: "Health", v: "91/100" }],
    details: [
      { icon: "🏢", label: "Branch System", value: "FIS Branch Teller · Jack Henry Core Director"                      },
      { icon: "📊", label: "Performance",   value: "FIS Branch Profitability · Cornerstone OnDemand LMS"               },
      { icon: "💳", label: "Payments",       value: "Nacha ACH · FedACH · NYCE ATM Network"                            },
    ],
  },
};

// ── AI INSIGHTS DATA ──────────────────────────────────────────────
export const AI_INSIGHTS: Record<string, {
  category: string; icon: string; color: string;
  insights: { tag: string; title: string; body: string; src: string }[];
}[]> = {
  ceo: [
    {
      category: "Market & Macro Intelligence", icon: "🌐", color: C.purple,
      insights: [
        {
          tag: "Fed Watch",
          title: "Two Fed rate cuts priced by CME futures for 2026 — NIM at risk",
          body:  "CME FedWatch implies 50bps cumulative cuts in 2026. The bank's liability-sensitive balance sheet projects NIM declining from 3.42% to 3.28%–3.30% by year-end, reducing NII by ~$8.2M annually.",
          src:   "CME FedWatch · Bancware ALM · FHLB Advance Rate Sheet",
        },
        {
          tag: "CA Economy",
          title: "Local CRE vacancy climbing to 11.2% — 3 credits showing DSCR compression",
          body:  "CoStar Q1 2026 data shows local MSA CRE vacancy up 180bps YoY. The bank's $1.04B non-owner CRE book faces NOI pressure. CRE concentration at 287% of capital.",
          src:   "CoStar CRE Market Analytics Q1 2026 · FDIC CRE Concentration Guidance",
        },
        {
          tag: "Competition",
          title: "Large bank opened 2 local MSA branches since January — deposit pricing pressure emerging",
          body:  "Large bank branch expansion is intensifying CD and MMDA pricing. Top competitor offering 5.00% on 12-month CDs vs. the bank's 4.60%. Estimated $40–$60M deposit flight risk.",
          src:   "FDIC Branch Office Survey · Moody's Deposit Competitive Analysis",
        },
      ],
    },
    {
      category: "Strategic Opportunity", icon: "💡", color: C.forest,
      insights: [
        {
          tag: "M&A Signal",
          title: "Tri-County Community Bank ($620M assets) in potential sale process",
          body:  "Public filings and board changes suggest Tri-County Community Bank is exploring strategic alternatives. Acquisition would add $620M assets, 4 branches. Est. EPS accretion 8–11% at 1.2x book.",
          src:   "FDIC Bank Find · CA DBO Filings · S&P Global M&A Database",
        },
        {
          tag: "SBA Growth",
          title: "SBA 7(a) volume 34% below CA peer median — $420K fee income available this quarter",
          body:  "7 existing clients are pre-qualified with on-file financials. Top RM's 73% SBA conversion rate is highest on the team.",
          src:   "SBA ETRAN Lender Volume · Internal LOS · CA SBA District Office Peer Reports",
        },
      ],
    },
  ],
  cfo: [
    {
      category: "Earnings & Forecast", icon: "📈", color: C.forest,
      insights: [
        {
          tag: "NIM Forecast",
          title: "NIM projected to compress to 3.28% by Q4 2026 under base rate scenario",
          body:  "Liability repricing accelerating (+11bps CoD QoQ). AFS portfolio has $8.2M in unrealized losses. Under 2 Fed cuts, full-year NII projected at $72.1M vs. $77.8M budget — $5.7M shortfall.",
          src:   "Bancware ALM · CME Fed Funds Futures · Bloomberg AFS",
        },
        {
          tag: "Budget",
          title: "Fee income outperforming (+$420K) — offset by personnel cost creep (+$310K)",
          body:  "SBA loan fee income and wire fees driving $420K positive fee variance. Healthcare renewal tracking $310K above budget.",
          src:   "FIS Horizon GL · Workday HRIS · FFIEC Call Report RI",
        },
      ],
    },
    {
      category: "Capital & Liquidity", icon: "🏦", color: C.gold,
      insights: [
        {
          tag: "Liquidity Stress",
          title: "Top 3 deposit concentrations: stress outflow modeled at $420M over 30 days",
          body:  "Under correlated-exit scenario (Metro Motors + Regional Ag Coop exit), 30-day outflow is $420M. Available liquidity $624M. Coverage ratio 148% — trending toward FDIC minimum of 125%.",
          src:   "Bancware Liquidity Stress Model · FDIC FIL-13-2023 · FHLB Collateral Report",
        },
      ],
    },
  ],
  banker: [
    {
      category: "Client Intelligence", icon: "🎯", color: C.forest,
      insights: [
        {
          tag: "Competitor Alert",
          title: "Wells Fargo credit inquiry on Sunrise Medical Group — Feb 24",
          body:  "Experian Business Credit Monitor flagged a Wells Fargo soft pull Feb 24. Account generates $28K annually. Pre-emptive outreach with rate hold has 3x higher retention rate.",
          src:   "Experian BIS Business Credit Monitor · Salesforce FSC Retention Model",
        },
        {
          tag: "Seasonal",
          title: "Almond bloom season begins March 15 — ag equipment financing spike 40%",
          body:  "USDA bloom forecast for the region is March 15–25. 14 drought-affected borrowers have elevated needs.",
          src:   "USDA NASS Almond Bloom Calendar · FIS Horizon AG LOC Utilization History",
        },
      ],
    },
    {
      category: "New Business", icon: "🏘️", color: C.gold,
      insights: [
        {
          tag: "New Licenses",
          title: "3 new CA SOS filings this week match SBA 7(a) profile in your territory",
          body:  "Eastview Dental Associates, City Tire & Lube, Coastal Imports LLC — all match SBA profile. Combined loan need: $1.8M.",
          src:   "CA Secretary of State Filings · SBA 7(a) SIC Approval Rate Database",
        },
      ],
    },
  ],
  ops: [
    {
      category: "Real-Time Risk", icon: "⚡", color: C.burgundy,
      insights: [
        {
          tag: "ACH Spike",
          title: "ACH return rate at 2.4% — 60% above Nacha threshold",
          body:  "R01 NSF and R02 Account Closed codes dominate. A regional employer had 2 payroll returns in 30 days — leading indicator of business distress.",
          src:   "FedACH Return Rate Monitor · Nacha ACH Rules 2026 · FIS Horizon Exception Queue",
        },
        {
          tag: "Training Gap",
          title: "Reg CC teller training at 61% — March 9 deadline is 7 days away",
          body:  "87 tellers have not completed Reg CC Hold Policy Update. Regional Hub and North Branch worst performers at 50% and 60%.",
          src:   "Cornerstone OnDemand LMS · Reg CC 12 CFR Part 229",
        },
      ],
    },
    {
      category: "Efficiency", icon: "⚙️", color: C.forest,
      insights: [
        {
          tag: "Branch",
          title: "Commerce Branch at $742 revenue/teller hour vs. West Branch at $401 — consolidation case builds",
          body:  "AI branch analysis shows Commerce Branch outperforming system average by 31%. West Branch below-average efficiency. CFO consolidation projects $420K annual savings.",
          src:   "FIS Branch Profitability Module · FDIC Branch Office Survey · Workday Teller Productivity",
        },
      ],
    },
  ],
  compliance: [
    {
      category: "Enforcement Intelligence", icon: "🔍", color: C.burgundy,
      insights: [
        {
          tag: "FinCEN Trend",
          title: "FinCEN March 2026 advisory: structuring rings targeting Central Valley ag businesses",
          body:  "FinCEN Advisory FIN-2026-A001 specifically flagged structuring deposits at community banks serving agricultural exporters in Central Valley. Account #4471 matches pattern exactly.",
          src:   "FinCEN Advisory FIN-2026-A001 · Verafin Pattern Engine · Bank Secrecy Act 31 U.S.C. § 5318(g)",
        },
        {
          tag: "FDIC Prep",
          title: "FDIC Risk Exam tentatively May 2026 — 14 overdue BSA reviews create MRA risk",
          body:  "FDIC examiners cited delayed high-risk customer annual reviews as an MRA in 68% of community bank exams in 2025.",
          src:   "FDIC Supervisory Findings Database 2025 · FFIEC BSA/AML Examination Manual",
        },
      ],
    },
    {
      category: "Regulatory Change", icon: "📰", color: C.gold,
      insights: [
        {
          tag: "CFPB Update",
          title: "CFPB finalized HMDA Regulation C updates effective March 10 — 6 exceptions must clear first",
          body:  "New HMDA fields cannot be properly populated until existing 6 exceptions are cleared. March 15 LAR deadline is only 5 days after rule effective date.",
          src:   "CFPB Regulation C Final Rule March 2026 · FFIEC HMDA Data Entry Software",
        },
      ],
    },
  ],
  lending: [
    {
      category: "Pipeline Intelligence", icon: "📝", color: C.cyan,
      insights: [
        {
          tag: "Pull-Through",
          title: "Pipeline pull-through at 76% — CRE stalls account for 18% of losses",
          body:  "8 active pipeline items totaling $14.1M. CRE appraisal delays average 14 days above benchmark. Prioritizing pre-appraisal ordering on new CRE submissions would recover $2.8M in stalled volume.",
          src:   "FIS Horizon LOS · CoStar Appraisal Network · Internal Pipeline Report",
        },
        {
          tag: "SBA Gap",
          title: "SBA volume 34% below CA community bank peer median — $420K fees available Q1",
          body:  "7 pre-qualified clients on file with complete financials. Top RM closes SBA at 73% vs. 58% team avg. Dedicated SBA specialist would add est. $1.2M annually in fee income.",
          src:   "SBA ETRAN Lender Volume · CA SBA District Office Peer Reports · Internal LOS",
        },
      ],
    },
    {
      category: "Market Opportunity", icon: "🏘️", color: C.forest,
      insights: [
        {
          tag: "Ag Season",
          title: "Almond bloom March 15 — ag equipment financing spike 40% historically",
          body:  "14 drought-affected borrowers in portfolio have elevated seasonal needs. USDA D3 designation may compress credit availability from competitors — positioning opportunity.",
          src:   "USDA NASS Almond Bloom Calendar · USDA Drought Monitor · FIS LOC Utilization History",
        },
        {
          tag: "CRE Cap",
          title: "CRE concentration at 287% — 4 pending CRE deals need ALCO waiver to close",
          body:  "Board cap is 300% of capital. LP-001 ($4.8M) and LP-005 ($3.2M) alone push to 298%. Recommend ALCO pre-approval before committing term sheets.",
          src:   "FFIEC CRE Concentration Guidance · AFS Credit Platform · FDIC Call Report RC-C",
        },
      ],
    },
  ],
  credit: [
    {
      category: "Portfolio Risk", icon: "📊", color: C.burgundy,
      insights: [
        {
          tag: "CRE Stress",
          title: "Local MSA CRE vacancy at 11.2% — 3 bank credits show DSCR below 1.20x",
          body:  "CoStar Q1 2026: Local CRE vacancy 11.2%, up 180bps YoY. Modeled DSCR impact: 9 credits projected to fall below 1.20x if vacancy rises another 100bps.",
          src:   "CoStar CRE Analytics Q1 2026 · Moody's CRE Stress Scenarios · AFS Credit Platform",
        },
        {
          tag: "Ag Drought",
          title: "USDA River County upgraded to D3 Extreme Drought Feb 20 — Q-factor may need to grow",
          body:  "D3 designation means crop yield reductions average 25–35% for almonds and pistachios. The $1.2M drought Q-factor may need to increase to $1.8M–$2.1M if D3 persists through June.",
          src:   "USDA Drought Monitor Feb 20, 2026 · USDA NASS Historical Yield Data · FASB ASC 326",
        },
      ],
    },
    {
      category: "Early Warning", icon: "🚨", color: C.gold,
      insights: [
        {
          tag: "Migration Risk",
          title: "Valley Ridge Growers: AI model predicts Substandard migration with 84% confidence",
          body:  "AI credit migration model flags Valley Ridge Growers at 84% probability. -18% revenue trend combined with 96% LOC utilization for 3 consecutive months.",
          src:   "AFS Credit AI Migration Model · USDA FSA Farm Income Report · Internal LOC Utilization History",
        },
      ],
    },
  ],
  cro: [
    {
      category: "Interest Rate Risk", icon: "📉", color: "#1E3A5F",
      insights: [
        {
          tag: "NIM Compression",
          title: "CME pricing 2 cuts in 2026 — liability-sensitive balance sheet at risk of -$8.2M NII",
          body:  "The bank's cost of deposits reprices faster than loan yields on a rate-cut path. Bancware ALM projects NIM falling from 3.42% to 3.28% by Q4 2026. Locking $100M FHLB 5-yr at 4.28% hedges ~$420K annually.",
          src:   "CME FedWatch · Bancware ALM Model · FHLB Rate Sheet Mar 2, 2026",
        },
        {
          tag: "EVE Sensitivity",
          title: "EVE at +200bps: +$12.4M (asset sensitive on equity basis) — within policy",
          body:  "Economic Value of Equity improves in rate-up scenarios due to the AFS portfolio offsetting fixed-rate liabilities. EVE stress -200bps shows -$18.6M which is within the -20% policy limit.",
          src:   "Bancware ALM · FRB SR 10-6 · OCC Interest Rate Risk Model Validation",
        },
      ],
    },
    {
      category: "Liquidity Risk", icon: "💧", color: C.gold,
      insights: [
        {
          tag: "Concentration Stress",
          title: "Correlated deposit exit stress: LCR drops to 88% — below 100% floor",
          body:  "If Metro Motors + Regional Ag Coop exit simultaneously (historically correlated during ag downturns), 30-day outflow hits $420M. HQLA of $651M plus $340M FHLB brings coverage to 110% — thin margin.",
          src:   "FDIC FIL-13-2023 · Bancware Liquidity Stress · FHLB Collateral Report Mar 2026",
        },
        {
          tag: "AFS Haircut",
          title: "$28.4M AFS unrealized loss reduces HQLA effective capacity — SVB-parallel risk",
          body:  "Post-SVB regulatory scrutiny focuses on AFS mark-to-market. The bank's AOCI of -$27.2M already flows through equity. AFS securities pledged to FHLB carry 95% advance rate — only $8.4M available for unencumbered HQLA.",
          src:   "FDIC FIL-13-2023 Liquidity Risk Guidance · Bloomberg AFS Mark-to-Market · FHLB Collateral Statement",
        },
      ],
    },
  ],
  mortgage: [
    {
      category: "Pipeline Intelligence", icon: "🏠", color: "#6B3D8A",
      insights: [
        {
          tag: "Rate Watch",
          title: "30yr fixed rate dropped 12bps last week — 82 borrowers on refi eligibility watch list",
          body:  "FNMA benchmark 30yr at 6.74% — 82 existing customers have rates >7.50% and sufficient equity for a no-cost refi. Estimated $4.8M in origination volume available. Average pull-through on proactive outreach is 34%.",
          src:   "FNMA Daily Rate Survey · FIS Horizon Servicing · Internal Refi Eligibility Model",
        },
        {
          tag: "HMDA Risk",
          title: "2 HMDA Reg C errors in Q1 LAR — submission deadline March 31",
          body:  "MG-007 Williams denial reason coding error (requires 3-reason format under new Reg C). MG-003 Washington income calculation excludes non-taxable Social Security — must be grossed up. Both correctable before March 31.",
          src:   "CFPB HMDA Reg C · FFIEC HMDA Check Software · Internal LAR File",
        },
      ],
    },
    {
      category: "Fair Lending", icon: "⚖️", color: C.forest,
      insights: [
        {
          tag: "CRA Impact",
          title: "3 of 8 pipeline loans qualify as LMI — tracking toward CRA performance target",
          body:  "MG-003 Washington, MG-005 Garcia, MG-007 Williams are all LMI borrowers in CRA assessment areas. Combined $1.05M counts toward lending test. Fair lending peer analysis shows denial rates 2.1% above peer median for Hispanic surnames in local MSA — monitor.",
          src:   "FFIEC HMDA Peer Data 2025 · CFPB Fair Lending ECOA Guidance · FFIEC CRA Guide",
        },
      ],
    },
  ],
  wealth: [
    {
      category: "Fiduciary Intelligence", icon: "⚖️", color: "#2C6B5F",
      insights: [
        {
          tag: "IPS Breach",
          title: "Regional Medical Pension equity allocation at 48% vs. 45% IPS limit — breach day 7",
          body:  "ERISA Section 404 prudent investor rule requires immediate rebalancing when IPS limits are breached. 7 days since breach detected. Fiduciary liability accrues daily. Recommended rebalance: sell $426K equities, rotate to fixed income.",
          src:   "ERISA Section 404 · OCC Trust Manual · Orion Advisor IPS Monitor",
        },
        {
          tag: "Fee Risk",
          title: "Valley Ag Holdings billed 0.50% vs. contracted 0.48% — $5,720 annual overbilling",
          body:  "Fee schedule mismatch identified in quarterly reconciliation. Trust accounting system rate table not updated after 2024 fee renegotiation. Client has not noticed yet — proactive correction and credit recommended before next statement.",
          src:   "SunGard Invest One Fee Ledger · Client Agreement dated Aug 2024",
        },
      ],
    },
    {
      category: "Growth Opportunity", icon: "💡", color: C.forest,
      insights: [
        {
          tag: "Estate Planning",
          title: "7 commercial banking clients with $2M+ net worth have no trust relationship — $14M AUM opportunity",
          body:  "Cross-referencing BOOK_OF_BUSINESS with wealth demographics: Martinez Family Trust ($4.2M loan), Sunrise Medical ($2.2M deposits), Valley Dental ($850K assets) — all meeting trust eligibility thresholds without existing wealth accounts.",
          src:   "Salesforce FSC · Internal Wealth Eligibility Scoring Model · FIS Horizon Balance Data",
        },
      ],
    },
  ],
  branch: [
    {
      category: "Performance Intelligence", icon: "📊", color: "#7A4F1D",
      insights: [
        {
          tag: "Teller Benchmark",
          title: "Commerce Branch leads at $814/teller revenue — West Branch at $401, 51% gap",
          body:  "Root cause analysis: Commerce Branch average transaction complexity is 38% higher (more commercial, fewer check cashing). West Branch has 2 tellers below 6,000 tx/month threshold. Peer coaching program from Commerce Branch mgr estimated +$180K annual revenue lift.",
          src:   "FIS Branch Profitability Module · Workday Teller Productivity · Internal HR Data",
        },
        {
          tag: "Deposit Gap",
          title: "Q1 network-wide deposit goal: $40M behind at 28 days to close",
          body:  "East and West Branch are furthest from goal. Recommended: CD special at 4.85% (matching market floor) for $500K+ accounts — projected to capture $22M in 3 weeks based on Feb CD campaign results.",
          src:   "FIS Horizon Deposit Tracking · Internal Branch Goal Sheet Q1 2026 · Competitor Rate Survey",
        },
      ],
    },
    {
      category: "Community Banking", icon: "🤝", color: C.forest,
      insights: [
        {
          tag: "Local Advantage",
          title: "Main Branch opens new DDA in 18 min avg vs. 42 min digital-only — speed advantage",
          body:  "Branch DDA account opening 18-min average vs. 42-min online for competitor digital-only banks. Small business owners cite local decision authority as #1 reason in Q4 2025 survey. New DDA campaign target: 120 accounts in March.",
          src:   "FIS Branch Teller Timing Data · Q4 2025 Customer Survey · Internal DDA Tracker",
        },
      ],
    },
  ],
};

// ── CUSTOMER AT-RISK PROFILES ─────────────────────────────────────
// Keyed by BOOK_OF_BUSINESS id — extends each client with behavioral scoring
export const CUSTOMER_RISK_PROFILES: Record<number, {
  atRiskScore: number;
  signal: string;
  wellnessScore: number;
  wellnessFlags: string[];
}> = {
  1: { atRiskScore: 0.61, signal: "Rate shopping inquiry Feb 18; deposits -12% MoM",              wellnessScore: 71, wellnessFlags: ["DSCR declining 1.42x→1.38x", "Maturity 59 days"]                        },
  2: { atRiskScore: 0.88, signal: "Competitor credit pull Feb 14; DSCR 1.11x (was 1.38x)",       wellnessScore: 48, wellnessFlags: ["Maturity Apr 16", "DSCR < 1.25x threshold", "Deposit balance low"]     },
  3: { atRiskScore: 0.74, signal: "Wells Fargo credit inquiry Feb 24; 48-hr retention window",    wellnessScore: 82, wellnessFlags: ["Competitor interest confirmed"]                                          },
  4: { atRiskScore: 0.79, signal: "LOC utilization 96% for 3 months; crop insurance unverified",  wellnessScore: 58, wellnessFlags: ["LOC utilization > 90%", "Revenue -18% YoY", "Insurance not verified"]  },
  5: { atRiskScore: 0.22, signal: "Treasury mgmt opportunity; stable relationship, low flight risk", wellnessScore: 86, wellnessFlags: []                                                                     },
  6: { atRiskScore: 0.18, signal: "New client; equipment LOC cross-sell Q2; strong DSCR 2.08x",  wellnessScore: 91, wellnessFlags: []                                                                        },
  7: { atRiskScore: 0.82, signal: "Anchor tenant vacant; deposit only $120K; NOI -22%",           wellnessScore: 52, wellnessFlags: ["NOI -22%", "Low deposit balance", "Lease rollover risk"]               },
  8: { atRiskScore: 0.31, signal: "New prospect; SBA eligible; no loan yet",                      wellnessScore: 74, wellnessFlags: ["No existing loan — single product"]                                     },
};

// ── CECL MULTI-SCENARIO STRESS TEST ──────────────────────────────
export const CECL_SCENARIOS = [
  { id: "S1", label: "S1 — Base",           gdp:  2.1, unemployment: 4.8, hpiChange:  1.2, provision:  40700000, aclRate: 0.0142, reserveStatus: "Adequate",  color: C.forest   },
  { id: "S2", label: "S2 — Mild Recession", gdp: -0.4, unemployment: 6.2, hpiChange: -2.8, provision:  62400000, aclRate: 0.0217, reserveStatus: "Adequate",  color: C.gold     },
  { id: "S3", label: "S3 — Severe",         gdp: -2.6, unemployment: 9.1, hpiChange:-14.2, provision: 112800000, aclRate: 0.0393, reserveStatus: "Stressed",  color: C.burgundy },
  { id: "S4", label: "S4 — Rate Shock",     gdp:  0.6, unemployment: 5.8, hpiChange: -5.2, provision:  74100000, aclRate: 0.0258, reserveStatus: "Monitor",   color: C.rust     },
  { id: "S5", label: "S5 — Ag + CRE",       gdp: -0.4, unemployment: 6.2, hpiChange: -8.6, provision:  88200000, aclRate: 0.0307, reserveStatus: "Monitor",   color: C.rust     },
];

// ── EXCEPTIONS QUEUE ──────────────────────────────────────────────
export interface Exception {
  id: string; type: string; category: string; customer: string;
  amount: number; issue: string; age: number;
  deadline: string | null; severity: string; assignee: string | null;
}
export const EXCEPTIONS: Exception[] = [
  { id:"EX-W-001", type:"Wire",        category:"OFAC",      customer:"Al Rashid Trading LLC",      amount:  28400, issue:"94% SDN partial match — outbound wire held pending BSA review",            age:4, deadline:"Today 10:42 AM", severity:"critical", assignee:"Kelly Ford"  },
  { id:"EX-A-001", type:"ACH",         category:"R01 NSF",   customer:"Metro Commercial Dist.",    amount:  14200, issue:"R01 NSF — payroll return, 2nd occurrence in 30 days",                     age:1, deadline:null,             severity:"high",     assignee:"Sam Morton" },
  { id:"EX-A-002", type:"ACH",         category:"R02 Closed",customer:"Riverside Row Crops LLC",   amount:   8100, issue:"R02 Account Closed — crop input supplier ACH rejected",                   age:1, deadline:null,             severity:"high",     assignee:"Sam Morton" },
  { id:"EX-A-003", type:"ACH",         category:"R10 Auth",  customer:"County Equipment Services", amount:  22800, issue:"R10 Unauthorized debit — customer disputes authorization",                 age:2, deadline:"Mar 4",          severity:"high",     assignee:"Sam Morton" },
  { id:"PP-001",   type:"Positive Pay", category:"Check",    customer:"Summit Family Trust",        amount:  84000, issue:"Payee mismatch — issued 'Western Title' presented 'Pacific Title'",       age:0, deadline:"Today 3:00 PM",  severity:"critical", assignee:null          },
  { id:"PP-002",   type:"Positive Pay", category:"Check",    customer:"Riverside Retail Partners",  amount: 124000, issue:"Check not issued — large dollar, possible internal fraud",                 age:0, deadline:"Today 3:00 PM",  severity:"critical", assignee:null          },
  { id:"PP-003",   type:"Positive Pay", category:"ACH",      customer:"Apex Medical Group",         amount:  18500, issue:"ACH not issued — payroll processor change not updated",                   age:0, deadline:"Today 3:00 PM",  severity:"critical", assignee:null          },
  { id:"PP-004",   type:"Positive Pay", category:"ACH",      customer:"Heritage Hardware & Supply", amount:   6400, issue:"Amount mismatch — issued $6,000, presented $6,400",                      age:0, deadline:"Today 3:00 PM",  severity:"high",     assignee:null          },
  { id:"EX-R-001", type:"Reg E",        category:"Dispute",  customer:"Eastview Family Medicine",   amount:   2100, issue:"Unauthorized ACH debit — provisional credit expires tomorrow",             age:8, deadline:"Tomorrow",       severity:"high",     assignee:"Sam Morton" },
  { id:"EX-R-002", type:"Reg E",        category:"Dispute",  customer:"Premier Dental Group",       amount:    840, issue:"POS fraud investigation — chargeback pending",                            age:5, deadline:"Mar 7",          severity:"medium",   assignee:"Sam Morton" },
  { id:"EX-O-001", type:"Override",     category:"OD Policy",customer:"Valley Ridge Growers",       amount:   4800, issue:"Overdraft exceeds $5K policy limit — branch manager approval required",   age:1, deadline:null,             severity:"medium",   assignee:null          },
];

// ── LENDING PIPELINE ──────────────────────────────────────────────
export interface PipelineItem {
  id: string; type: string; borrower: string; amount: number;
  stage: string; daysIn: number; rm: string;
  ltv: number | null; rate: number | null;
  closeTarget: string; issue: string | null;
}
export const LENDING_PIPELINE: PipelineItem[] = [
  { id:"LP-001", type:"CRE",       borrower:"Metro Commerce LLC",          amount:4800000, stage:"Underwriting", daysIn:12, rm:"J. Reed",   ltv:0.68, rate:6.75, closeTarget:"Apr 15", issue:"Environmental Phase 1 ordered — 15 days"        },
  { id:"LP-002", type:"C&I",       borrower:"Regional Medical Partners",  amount:2100000, stage:"Pre-approval",  daysIn: 5, rm:"J. Reed",   ltv:null, rate:7.25, closeTarget:"Mar 28", issue:null                                              },
  { id:"LP-003", type:"SBA 7(a)",  borrower:"Apex Medical Group",         amount: 800000, stage:"Processing",   daysIn:22, rm:"J. Reed",   ltv:null, rate:null,  closeTarget:"Apr 30", issue:"SBA CAIVRS clearance pending"                    },
  { id:"LP-004", type:"Ag LOC",    borrower:"Valley Orchards Group",      amount:1200000, stage:"Committee",    daysIn: 8, rm:"M. Torres", ltv:0.55, rate:8.00,  closeTarget:"Mar 20", issue:"Borrowing base calculation needed"                },
  { id:"LP-005", type:"CRE",       borrower:"Eastview Commerce Center",   amount:3200000, stage:"Term Sheet",   daysIn: 2, rm:"M. Torres", ltv:0.70, rate:6.90,  closeTarget:"May 15", issue:null                                              },
  { id:"LP-006", type:"Equipment", borrower:"Westbrook Trucking Inc.",    amount: 480000, stage:"Approved",     daysIn:18, rm:"K. Perry",  ltv:0.80, rate:7.50,  closeTarget:"Mar 10", issue:"Pending title search — 2 days"                   },
  { id:"LP-007", type:"SBA 504",   borrower:"Premier Dental Group",       amount: 650000, stage:"SBA Review",  daysIn:31, rm:"J. Reed",   ltv:0.41, rate:null,  closeTarget:"May 30", issue:"In SBA review — normal processing"               },
  { id:"LP-008", type:"C&I LOC",   borrower:"River County Farmland Trust",amount: 900000, stage:"Underwriting", daysIn:14, rm:"K. Perry",  ltv:null, rate:7.75,  closeTarget:"Apr 1",  issue:"Crop insurance verification required"            },
];

// ── INVESTMENT PORTFOLIO ──────────────────────────────────────────
export const INVESTMENT_PORTFOLIO = {
  totalSecurities:   612000000,
  afs: {
    total:           421000000,
    unrealizedLoss:  -28400000,
    unrealizedGain:    1200000,
    aoci:            -27200000,
    duration:          5.8,
    holdings: [
      { type: "Agency MBS",          bal: 164000000, dur: 6.4, coupon: 2.50, unrealized: -14200000, matBucket: ">10yr" },
      { type: "US Treasuries",        bal:  98000000, dur: 4.1, coupon: 1.75, unrealized:  -7100000, matBucket: "5–10yr" },
      { type: "Agency CMBS",          bal:  84000000, dur: 6.8, coupon: 2.25, unrealized:  -5400000, matBucket: ">10yr" },
      { type: "Muni Bonds (Tax-Ex)",  bal:  52000000, dur: 4.9, coupon: 3.10, unrealized:    -900000, matBucket: "3–5yr" },
      { type: "Corp Bonds (A-rated)", bal:  23000000, dur: 2.8, coupon: 4.50, unrealized:     400000, matBucket: "1–3yr" },
    ],
  },
  htm: {
    total:           191000000,
    bookValue:       191000000,
    fairValue:       168400000,
    unrealizedLoss:  -22600000, // not in AOCI — disclosed only
    duration:          8.2,
    holdings: [
      { type: "Agency MBS",    bal: 122000000, dur: 8.9, coupon: 1.875, fairValue: 106800000 },
      { type: "US Treasuries", bal:  69000000, dur: 6.8, coupon: 1.625, fairValue:  61600000 },
    ],
  },
  cashFlow: [
    { month: "Mar 26", principal:  4200000, coupon:  980000 },
    { month: "Apr 26", principal:  3800000, coupon:  960000 },
    { month: "May 26", principal:  5100000, coupon: 1020000 },
    { month: "Jun 26", principal:  4600000, coupon:  980000 },
    { month: "Jul 26", principal:  3400000, coupon:  960000 },
    { month: "Aug 26", principal:  6200000, coupon: 1040000 },
  ],
};

// ── CD MATURITY LADDER ────────────────────────────────────────────
export const CD_MATURITY_LADDER = {
  totalTimeDeposits: 427000000,
  avgRate:           4.42,
  buckets: [
    { label: "< 3 Months",   amount: 48000000,  rate: 4.85, pct: 11.2, repricingRisk: "high",   color: "#7B1C2E" },
    { label: "3–6 Months",   amount: 92000000,  rate: 4.72, pct: 21.5, repricingRisk: "high",   color: "#8B4A2A" },
    { label: "6–12 Months",  amount: 138000000, rate: 4.55, pct: 32.3, repricingRisk: "medium", color: "#B8860B" },
    { label: "12–18 Months", amount:  74000000, rate: 4.38, pct: 17.3, repricingRisk: "medium", color: "#2C5F3F" },
    { label: "18–24 Months", amount:  48000000, rate: 4.10, pct: 11.2, repricingRisk: "low",    color: "#2C5F6A" },
    { label: "> 24 Months",  amount:  27000000, rate: 3.85, pct:  6.5, repricingRisk: "low",    color: "#4A3728" },
  ],
  rateExceptions: [
    { customer: "Metro Motors Group",      amount: 12000000, approvedRate: 5.10, ceilingRate: 4.85, exception: "+25bps", approver: "L. Owens", date: "Feb 14" },
    { customer: "Regional Ag Cooperative",amount:  8400000, approvedRate: 5.00, ceilingRate: 4.85, exception: "+15bps", approver: "L. Owens", date: "Jan 28" },
    { customer: "County School District", amount:  6200000, approvedRate: 4.95, ceilingRate: 4.85, exception: "+10bps", approver: "J. Wright",  date: "Feb 2" },
    { customer: "Regional Health System", amount:  3800000, approvedRate: 4.90, ceilingRate: 4.85, exception: "+5bps",  approver: "L. Owens", date: "Mar 1" },
  ],
};

// ── LCR / NSFR ───────────────────────────────────────────────────
export const LIQUIDITY_METRICS = {
  hqla: {
    l1:          184000000, // Cash + Fed reserves
    l2a:         421000000, // AFS agency securities (after haircut)
    l2b:          46000000, // Other AFS (after haircut)
    total:       651000000,
  },
  thirtyDayOutflows: {
    retailDeposits:          36200000,
    smallBizDeposits:        18400000,
    largeCorpDeposits:       84200000, // top concentrations
    fhlbMaturities:          40000000,
    other:                   12400000,
    total:                  191200000,
  },
  thirtyDayInflows: {
    loanPrincipal:            14200000,
    securitiesCashFlow:       10800000,
    other:                     4200000,
    total:                    29200000,
  },
  lcr: 1.82,  // 182% — well above 100% minimum
  nsfr: 1.24, // 124%
  contingencyCapacity: [
    { source: "FHLB Undrawn",              amount: 340000000, available: true  },
    { source: "FRB Discount Window",       amount: 280000000, available: true  },
    { source: "Brokered CD Capacity",      amount: 120000000, available: true  },
    { source: "Fed Funds Purchased",       amount:  80000000, available: true  },
    { source: "IntraFi CDARS",             amount: 300000000, available: true  },
  ],
  stressOutflows: [
    { scenario: "Base (30-day)",          outflow: 191200000, coverage: 1.82, color: "#2C5F3F" },
    { scenario: "Top 3 Depositor Exit",   outflow: 420000000, coverage: 1.10, color: "#B8860B" },
    { scenario: "Correlated Stress",      outflow: 580000000, coverage: 0.88, color: "#7B1C2E" },
    { scenario: "Run-on-Bank (SVB-like)", outflow: 840000000, coverage: 0.61, color: "#7B1C2E" },
  ],
};

// ── MORTGAGE / CONSUMER PIPELINE ─────────────────────────────────
export const MORTGAGE_PIPELINE = [
  { id:"MG-001", borrower:"Rodriguez, M & J",   purpose:"Purchase",  type:"Conv 30yr",  amount: 485000, rate: 6.875, lock:"Mar 15",  daysToLock: 13, ltv: 0.80, fico: 742, status:"Underwriting",  hmda: true,  lmi: false },
  { id:"MG-002", borrower:"Patel, S",            purpose:"Refi",      type:"Conv 15yr",  amount: 312000, rate: 6.250, lock:"Mar 22",  daysToLock: 20, ltv: 0.62, fico: 798, status:"Conditional",   hmda: true,  lmi: false },
  { id:"MG-003", borrower:"Washington, D",       purpose:"Purchase",  type:"FHA 30yr",   amount: 348000, rate: 7.250, lock:"Mar 18",  daysToLock: 16, ltv: 0.96, fico: 658, status:"Approved",      hmda: true,  lmi: true  },
  { id:"MG-004", borrower:"Kim, Y & H",          purpose:"Purchase",  type:"Conv 30yr",  amount: 622000, rate: 6.750, lock:"Apr 2",   daysToLock: 31, ltv: 0.75, fico: 771, status:"Processing",    hmda: true,  lmi: false },
  { id:"MG-005", borrower:"Garcia, R",           purpose:"Refi",      type:"VA 30yr",    amount: 418000, rate: 6.125, lock:"Mar 28",  daysToLock: 26, ltv: 0.84, fico: 724, status:"Docs Ordered",  hmda: true,  lmi: true  },
  { id:"MG-006", borrower:"Chen, L & M",         purpose:"Purchase",  type:"Jumbo 30yr", amount: 920000, rate: 7.000, lock:"Apr 10",  daysToLock: 39, ltv: 0.70, fico: 810, status:"Underwriting",  hmda: true,  lmi: false },
  { id:"MG-007", borrower:"Williams, T",         purpose:"Purchase",  type:"FHA 30yr",   amount: 285000, rate: 7.375, lock:"Mar 25",  daysToLock: 23, ltv: 0.96, fico: 641, status:"Suspended",     hmda: true,  lmi: true  },
  { id:"MG-008", borrower:"Nguyen, P & Q",       purpose:"Refi",      type:"Conv 30yr",  amount: 510000, rate: 6.625, lock:"Apr 5",   daysToLock: 34, ltv: 0.68, fico: 756, status:"Approved",      hmda: true,  lmi: false },
];

export const CONSUMER_LOANS = [
  { id:"CL-001", type:"Auto",      borrower:"Lopez, A",        amount:  48000, rate: 7.99, term: 72, fico: 691, status:"Approved",  issue: null },
  { id:"CL-002", type:"HELOC",     borrower:"Jackson, M",      amount: 120000, rate: 8.50, term:120, fico: 728, status:"Closing",   issue: null },
  { id:"CL-003", type:"Personal",  borrower:"Ramirez, C",      amount:  18000, rate:11.25, term: 60, fico: 642, status:"Declined",  issue:"DTI exceeds 45%" },
  { id:"CL-004", type:"Student",   borrower:"Patel, N",        amount:  35000, rate: 6.50, term:120, fico: 718, status:"Approved",  issue: null },
  { id:"CL-005", type:"Auto",      borrower:"Morrison, B",     amount:  31000, rate: 8.49, term: 60, fico: 703, status:"Processing",issue: null },
];

// ── WEALTH / TRUST ────────────────────────────────────────────────
export const WEALTH_DATA = {
  aum:            284000000,
  aumQoQChange:    0.042,
  feeIncome:        2840000,   // annual
  feeIncomeMTD:     198000,
  accounts:           142,
  discretionary:      98,
  agency:             44,
  avgAccountSize:   2000000,
  fiduciaryRisk:    "medium",
  accounts_list: [
    { name: "Highlands Family Trust",    type: "Irrevocable Trust", aum: 12400000, riskProfile: "Moderate",    feeYTD: 62000,  nextReview: "Apr 14", cm: "S. Cole",  status: "Current"   },
    { name: "Inland Ag Holdings LLC",   type: "Investment Mgmt",   aum: 28600000, riskProfile: "Growth",      feeYTD: 143000, nextReview: "Mar 28", cm: "S. Cole",  status: "Current"   },
    { name: "County School Foundation", type: "Foundation",        aum:  8200000, riskProfile: "Conservative",feeYTD: 41000,  nextReview: "May 1",  cm: "R. Park",  status: "Current"   },
    { name: "Lakewood Testamentary Trust",type:"Testamentary Trust",aum:  4800000, riskProfile: "Conservative",feeYTD: 24000,  nextReview: "Mar 10", cm: "R. Park",  status: "Overdue"   },
    { name: "Meridian Family Office",   type: "Investment Mgmt",   aum: 18400000, riskProfile: "Aggressive",  feeYTD: 92000,  nextReview: "Apr 20", cm: "S. Cole",  status: "Current"   },
    { name: "Regional Medical Pension", type: "ERISA Plan",        aum: 14200000, riskProfile: "Moderate",    feeYTD: 71000,  nextReview: "Mar 15", cm: "R. Park",  status: "At Risk"   },
  ],
  assetAllocation: [
    { cls: "Equities",       pct: 0.42, val: 119280000 },
    { cls: "Fixed Income",   pct: 0.35, val:  99400000 },
    { cls: "Alternatives",   pct: 0.12, val:  34080000 },
    { cls: "Cash & MMF",     pct: 0.11, val:  31240000 },
  ],
  fiduciaryAlerts: [
    { type: "Annual Review Overdue",   account: "Lakewood Testamentary Trust", daysOverdue: 12, priority: "high"     },
    { type: "Investment Policy Breach",account: "Regional Medical Pension",   detail: "Equity allocation 48% vs 45% IPS limit", priority: "critical" },
    { type: "Fee Schedule Mismatch",   account: "Inland Ag Holdings LLC",     detail: "Contract rate 0.48% billed at 0.50%",    priority: "medium"   },
    { type: "Successor Trustee Void",  account: "County School Foundation",   detail: "Named successor resigned, no replacement filed", priority: "high" },
  ],
};

// ── BRANCH PERFORMANCE ────────────────────────────────────────────
export const BRANCH_DATA = [
  { id:"B01", name:"Main Branch",        city:"Metro",         mgr:"L. Todd",   deposits: 684000000, loans: 248000000, tellers:8,  txPerTeller: 9820, revenuePerTeller: 742, errorRate: 0.00021, healthScore: 91, costPerDollar: 0.22, goal: 700000000, ytdNewDDA: 84, ytdNewLoans: 18 },
  { id:"B02", name:"North Branch",       city:"Northside",     mgr:"A. Park",   deposits: 312000000, loans: 142000000, tellers:5,  txPerTeller: 8940, revenuePerTeller: 681, errorRate: 0.00038, healthScore: 82, costPerDollar: 0.24, goal: 340000000, ytdNewDDA: 52, ytdNewLoans: 12 },
  { id:"B03", name:"South Branch",       city:"Southgate",     mgr:"M. Cole",   deposits: 178000000, loans:  94000000, tellers:4,  txPerTeller: 7820, revenuePerTeller: 598, errorRate: 0.00042, healthScore: 74, costPerDollar: 0.27, goal: 200000000, ytdNewDDA: 34, ytdNewLoans:  8 },
  { id:"B04", name:"East Branch",        city:"Eastview",      mgr:"T. King",   deposits: 142000000, loans:  68000000, tellers:3,  txPerTeller: 6940, revenuePerTeller: 524, errorRate: 0.00055, healthScore: 68, costPerDollar: 0.31, goal: 160000000, ytdNewDDA: 24, ytdNewLoans:  6 },
  { id:"B05", name:"West Branch",        city:"Westside",      mgr:"P. Stone",  deposits: 218000000, loans:  98000000, tellers:5,  txPerTeller: 6410, revenuePerTeller: 401, errorRate: 0.00062, healthScore: 61, costPerDollar: 0.31, goal: 240000000, ytdNewDDA: 28, ytdNewLoans:  7 },
  { id:"B06", name:"Commerce Branch",    city:"Commerce Park", mgr:"D. North",  deposits: 196000000, loans:  88000000, tellers:4,  txPerTeller:10240, revenuePerTeller: 814, errorRate: 0.00018, healthScore: 94, costPerDollar: 0.20, goal: 210000000, ytdNewDDA: 48, ytdNewLoans: 11 },
  { id:"B07", name:"Regional Hub",       city:"Lakeside",      mgr:"R. Marsh",  deposits: 284000000, loans: 124000000, tellers:6,  txPerTeller: 8120, revenuePerTeller: 628, errorRate: 0.00044, healthScore: 77, costPerDollar: 0.26, goal: 300000000, ytdNewDDA: 62, ytdNewLoans: 14 },
];

// ── WATCHLIST / LOAN FILE DATA ────────────────────────────────────
export const WATCHLIST_CREDITS = [
  {
    id: "WL-001", name: "Meridian Properties Group", type: "CRE",   bal: 6700000,
    cls: "Special Mention", rm: "J. Reed",    lastReview: "Dec 14, 2025",
    nextReview: "Mar 14, 2026", dscr: 1.11, ltv: 0.72, occupancy: 0.74,
    maturity: "Apr 16, 2026", rate: 6.75, collateral: "Office complex — Meridian Street, Metro City",
    creditMemo: "Borrower is an LLC holding a 42,000 sq ft office complex in downtown Metro City. DSCR declining from 1.38x (2024) to 1.11x due to anchor tenant Space Solutions vacating in Q3 2025. Current vacancy 26%. Guarantor R. Garrett has net worth $4.2M with 40% concentration in subject property. Maturity April 16 — refinance options limited given current market conditions.",
    actions: [
      { date: "Feb 14, 2026", user: "D. Norris", action: "Classified Special Mention — DSCR below 1.20x trigger", done: true },
      { date: "Mar 2, 2026",  user: "J. Reed",   action: "Contacted borrower re: refinance options", done: true },
      { date: "Mar 14, 2026", user: "D. Norris", action: "Annual review due — updated operating statement required", done: false },
      { date: "Apr 5, 2026",  user: "Credit Cmte", action: "Watchlist Committee sign-off required before maturity", done: false },
    ],
    committeeStatus: "Pending", committeeDate: "Apr 5, 2026",
  },
  {
    id: "WL-002", name: "Valley Ridge Growers",    type: "Ag LOC", bal: 1800000,
    cls: "Special Mention", rm: "J. Reed",    lastReview: "Oct 1, 2025",
    nextReview: "Mar 15, 2026", dscr: 1.28, ltv: 0.55, occupancy: null,
    maturity: "Oct 1, 2026", rate: 8.00, collateral: "Cropland — River County 480 acres",
    creditMemo: "Established ag borrower since 2016. Primary crop almonds (60%) and cotton (40%). LOC utilization at 96% for 3 consecutive months — atypical for this stage of crop cycle. Revenue declined 18% YoY per 2025 tax returns. River County elevated to D3 Extreme Drought Feb 20. Crop insurance certificate requested but not received.",
    actions: [
      { date: "Jan 15, 2026", user: "J. Reed",   action: "Flagged high LOC utilization to credit", done: true },
      { date: "Feb 20, 2026", user: "D. Norris", action: "USDA D3 drought designation — enhanced monitoring", done: true },
      { date: "Mar 15, 2026", user: "J. Reed",   action: "Crop insurance verification — downgrade if not received", done: false },
      { date: "Mar 31, 2026", user: "Credit Cmte", action: "Watchlist review — Substandard classification decision", done: false },
    ],
    committeeStatus: "Pending", committeeDate: "Mar 31, 2026",
  },
  {
    id: "WL-003", name: "Riverside Retail Partners",type:"CRE",    bal: 4200000,
    cls: "Special Mention", rm: "J. Reed",    lastReview: "Nov 20, 2025",
    nextReview: "Apr 1, 2026", dscr: 1.09, ltv: 0.68, occupancy: 0.61,
    maturity: "Dec 1, 2026", rate: 6.50, collateral: "Riverside retail strip — 18,000 sq ft",
    creditMemo: "Retail strip center in Southgate. Anchor tenant (38% of GLA) vacated Q4 2025. NOI declined 22%. Borrower has not provided updated rent roll despite repeated requests since January. Remaining tenants on month-to-month. LTV now estimated 68% vs. 58% at origination based on updated CoStar comp data.",
    actions: [
      { date: "Jan 30, 2026", user: "J. Reed",   action: "Requested updated rent roll — no response", done: true },
      { date: "Feb 14, 2026", user: "D. Norris", action: "Placed on watchlist — Special Mention", done: true },
      { date: "Mar 10, 2026", user: "J. Reed",   action: "Second request — operating statements due", done: false },
      { date: "Apr 1, 2026",  user: "Credit Cmte", action: "Watchlist Committee review required", done: false },
    ],
    committeeStatus: "Scheduled", committeeDate: "Apr 1, 2026",
  },
];

// ── LOAN MODIFICATIONS / FORBEARANCE ─────────────────────────────
export const LOAN_MODIFICATIONS = [
  { id:"LM-001", borrower:"Summit Storage LLC",      type:"CRE",     bal:  890000, modType:"Rate Reduction", origRate:7.50, modRate:6.00, term:"6 months", reason:"Legal hold + guarantor distress", tdr: true,  expiryDate:"Jun 30, 2026", status:"Active"    },
  { id:"LM-002", borrower:"Westbrook Trucking Inc.", type:"C&I",     bal: 2100000, modType:"Payment Deferral",origRate:7.50, modRate:7.50, term:"3 months", reason:"Covenant breach — cash flow",   tdr: false, expiryDate:"May 31, 2026", status:"Active"    },
  { id:"LM-003", borrower:"Metro Auto Parts",        type:"C&I",     bal:  420000, modType:"Term Extension",  origRate:8.00, modRate:8.00, term:"12 months",reason:"In collections",                tdr: true,  expiryDate:"Feb 28, 2027", status:"Active"    },
  { id:"LM-004", borrower:"Riverside Row Crops LLC", type:"Ag LOC",  bal: 4100000, modType:"LOC Limit Cut",   origRate:8.25, modRate:8.25, term:"Permanent",reason:"Drought impact — reduced capacity",tdr:false, expiryDate:"N/A",          status:"Permanent" },
];

// ── AG CROP CONCENTRATION ─────────────────────────────────────────
export const AG_CROP_CONCENTRATION = [
  { crop: "Almonds",    balance: 168000000, pct: 0.384, accounts: 24, droughtImpact: "high",   yieldRisk: "25–35% reduction under D3",   insuranceVerified: 14, insuranceTotal: 24, avgLTV: 0.52 },
  { crop: "Pistachios", balance:  94000000, pct: 0.215, accounts: 12, droughtImpact: "high",   yieldRisk: "20–30% reduction under D3",   insuranceVerified:  8, insuranceTotal: 12, avgLTV: 0.48 },
  { crop: "Cotton",     balance:  72000000, pct: 0.164, accounts: 18, droughtImpact: "medium", yieldRisk: "15–20% reduction",             insuranceVerified: 16, insuranceTotal: 18, avgLTV: 0.61 },
  { crop: "Wine Grapes",balance:  58000000, pct: 0.132, accounts:  9, droughtImpact: "medium", yieldRisk: "10–15% quality downgrade",     insuranceVerified:  5, insuranceTotal:  9, avgLTV: 0.44 },
  { crop: "Dairy/Feed", balance:  28000000, pct: 0.064, accounts:  8, droughtImpact: "low",    yieldRisk: "Feed cost inflation +18%",     insuranceVerified:  8, insuranceTotal:  8, avgLTV: 0.58 },
  { crop: "Row Crops",  balance:  18000000, pct: 0.041, accounts: 11, droughtImpact: "low",    yieldRisk: "Minimal — surface water rights",insuranceVerified: 11, insuranceTotal: 11, avgLTV: 0.55 },
];

// ── FRAUD / CARD DISPUTES ─────────────────────────────────────────
export const FRAUD_DISPUTES = [
  { id:"FD-001", type:"Card Fraud",    customer:"Summit Family Trust",      amount: 4280,  date:"Mar 1",   status:"Investigating", provisionalCredit: true,  deadline:"Mar 8",  channel:"POS — Out of Area", risk:"high"   },
  { id:"FD-002", type:"Card Fraud",    customer:"Premier Dental Group",     amount:  840,  date:"Mar 1",   status:"Resolved",      provisionalCredit: false, deadline:"Done",   channel:"CNP — Online",      risk:"low"    },
  { id:"FD-003", type:"Dispute",       customer:"Heritage Hardware & Supply",amount:2100,  date:"Feb 28",  status:"Chargeback",    provisionalCredit: true,  deadline:"Mar 7",  channel:"POS — Vendor",      risk:"medium" },
  { id:"FD-004", type:"Card Fraud",    customer:"Eastview Family Medicine", amount: 6480,  date:"Feb 27",  status:"Investigating", provisionalCredit: true,  deadline:"Mar 6",  channel:"ATM — Out of Area", risk:"high"   },
  { id:"FD-005", type:"Dispute",       customer:"Valley Ridge Growers",     amount:  320,  date:"Feb 26",  status:"Resolved",      provisionalCredit: false, deadline:"Done",   channel:"POS — Gas Station", risk:"low"    },
  { id:"FD-006", type:"Synthetic ID",  customer:"[New Account 8812]",       amount:12400,  date:"Mar 2",   status:"Blocked",       provisionalCredit: false, deadline:"Today",  channel:"Digital Onboarding",risk:"critical"},
];

// ── IT TICKETS ────────────────────────────────────────────────────
export const IT_TICKETS = [
  { id:"INC-2241", title:"Core banking slow — Main Branch teller windows",   priority:"critical", cat:"Performance",  assignee:"B. Walsh",    created:"Mar 2",  sla:"4hr",   status:"In Progress", hoursOpen: 2 },
  { id:"INC-2238", title:"Online banking password reset loop — 14 users",   priority:"high",     cat:"Authentication",assignee:"A. Shah",     created:"Mar 1",  sla:"8hr",   status:"In Progress", hoursOpen: 18 },
  { id:"INC-2234", title:"ACH file transmission delay — 3 PM batch",        priority:"high",     cat:"Payments",     assignee:"B. Walsh",    created:"Feb 28", sla:"8hr",   status:"Escalated",   hoursOpen: 41 },
  { id:"INC-2228", title:"Verafin BSA alert engine — false positive spike",  priority:"medium",   cat:"BSA/Compliance",assignee:"A. Shah",     created:"Feb 26", sla:"24hr",  status:"In Progress", hoursOpen: 60 },
  { id:"INC-2220", title:"Cornerstone LMS — Reg CC course not recording",   priority:"medium",   cat:"LMS",          assignee:"C. North",    created:"Feb 24", sla:"24hr",  status:"Pending",     hoursOpen: 84 },
  { id:"INC-2215", title:"Branch vault cam offline — North Branch",          priority:"high",     cat:"Physical Sec", assignee:"B. Walsh",    created:"Feb 23", sla:"4hr",   status:"Breached",    hoursOpen:108 },
  { id:"INC-2190", title:"Workday payroll integration — GL variance",        priority:"medium",   cat:"Finance/GL",   assignee:"C. North",    created:"Feb 18", sla:"48hr",  status:"Pending",     hoursOpen:192 },
];

// ── BCP / DISASTER RECOVERY ───────────────────────────────────────
export const BCP_DATA = {
  lastFullTest: "Sep 12, 2025",
  nextScheduled: "Mar 28, 2026",
  overallScore: 78,
  components: [
    { name: "Core Banking Failover",    score: 88, rto: "4hr",  rpo: "1hr",  lastTested: "Sep 2025", status: "Tested"  },
    { name: "Online/Mobile Banking",    score: 82, rto: "2hr",  rpo: "15min",lastTested: "Sep 2025", status: "Tested"  },
    { name: "ACH / Payments",           score: 76, rto: "8hr",  rpo: "2hr",  lastTested: "Sep 2025", status: "Tested"  },
    { name: "Branch Operations",        score: 71, rto: "24hr", rpo: "4hr",  lastTested: "Mar 2025", status: "Stale"   },
    { name: "Data Center — Primary",    score: 94, rto: "1hr",  rpo: "15min",lastTested: "Sep 2025", status: "Tested"  },
    { name: "Data Center — DR Site",    score: 88, rto: "4hr",  rpo: "1hr",  lastTested: "Sep 2025", status: "Tested"  },
    { name: "Vendor Continuity (FIS)",  score: 64, rto: "24hr", rpo: "4hr",  lastTested: "Jun 2024", status: "Overdue" },
    { name: "Communication Plan",       score: 58, rto: "N/A",  rpo: "N/A",  lastTested: "Mar 2025", status: "Stale"   },
  ],
};

// ── DEPOSIT PROFITABILITY ─────────────────────────────────────────
export const DEPOSIT_PROFITABILITY = {
  totalDeposits: 3620000000,
  avgCostOfFunds: 0.0194,
  earningsCreditRate: 0.0480,
  fullyLoadedCOF: 0.0238, // including non-interest expense allocation
  segments: [
    { name: "Non-Interest DDA",      balance: 775000000, rate: 0.000, servCost: 0.0042, netSpread: 0.0458, annualProfit: 3551000,  accounts: 3210, profitability: "high"   },
    { name: "Commercial DDA",        balance: 842000000, rate: 0.000, servCost: 0.0082, netSpread: 0.0398, annualProfit: 3351000,  accounts: 284,  profitability: "high"   },
    { name: "MMDA — Business",       balance: 624000000, rate: 0.0310, servCost: 0.0194, netSpread: 0.0286, annualProfit: 1785000, accounts: 182,  profitability: "high"   },
    { name: "Municipal / Govt",      balance: 312000000, rate: 0.0280, servCost: 0.0168, netSpread: 0.0312, annualProfit: 974000,  accounts: 42,   profitability: "high"   },
    { name: "Retail Checking (Int)", balance: 228000000, rate: 0.0050, servCost: 0.0124, netSpread: 0.0226, annualProfit: 515000,  accounts: 8420, profitability: "medium" },
    { name: "Retail Savings",        balance: 412000000, rate: 0.0185, servCost: 0.0210, netSpread: 0.0132, annualProfit: 544000,  accounts: 4820, profitability: "medium" },
    { name: "CD / Time Deposits",    balance: 427000000, rate: 0.0442, servCost: 0.0480, netSpread: -0.0038,annualProfit: -162000, accounts: 1240, profitability: "low"    },
  ],
  topRelationships: [
    { name: "Metro Motors Group",       balance: 284000000, type: "Auto Dealer",  products: 4, rate: 0.051, ecr: 0.048, annualProfit: 280000, risk: "critical", profCheck: "Rate exception +25bps erodes margin" },
    { name: "Regional Ag Cooperative", balance: 218000000, type: "Ag Business",  products: 3, rate: 0.048, ecr: 0.048, annualProfit: 198000, risk: "critical", profCheck: "Single-product — no fee offset" },
    { name: "County School District",  balance:  92000000, type: "Govt / Muni",  products: 2, rate: 0.028, ecr: 0.048, annualProfit: 184000, risk: "medium",   profCheck: "ECR offset; highly profitable" },
    { name: "Regional Health System",  balance:  78000000, type: "Healthcare",   products: 5, rate: 0.032, ecr: 0.048, annualProfit: 142000, risk: "medium",   profCheck: "5 products — model relationship" },
    { name: "Apex Medical Group",      balance:  46000000, type: "C&I",          products: 5, rate: 0.024, ecr: 0.048, annualProfit: 118000, risk: "low",      profCheck: "Highest RoR per dollar — protect" },
    { name: "Heritage Hardware & Supply",balance: 18000000,type: "Small Biz",    products: 4, rate: 0.000, ecr: 0.000, annualProfit:  82000, risk: "low",      profCheck: "Non-interest DDA — pure spread" },
  ],
};

// ── HMDA LAR RECORDS ─────────────────────────────────────────────
export const HMDA_LAR = [
  { id:"LAR-001", applicant:"Rodriguez, M & J", race:"Hispanic/Latino",         gender:"Male",   age:34, income:124000, loanAmt:485000, purpose:"Purchase", type:"Conv 30yr", action:"Originated", denial: null,                                       tract:"2008.04", lmi:false, flag: null },
  { id:"LAR-002", applicant:"Patel, S",          race:"Asian",                   gender:"Female", age:41, income:198000, loanAmt:312000, purpose:"Refi",     type:"Conv 15yr", action:"Originated", denial: null,                                       tract:"2012.01", lmi:false, flag: null },
  { id:"LAR-003", applicant:"Washington, D",     race:"Black/African American",  gender:"Male",   age:28, income:68000,  loanAmt:348000, purpose:"Purchase", type:"FHA 30yr",  action:"Originated", denial: null,                                       tract:"2011.01", lmi:true,  flag:"Income grossup required — SS non-taxable must be included (CFPB Reg C)" },
  { id:"LAR-004", applicant:"Kim, Y & H",        race:"Asian",                   gender:"Female", age:45, income:244000, loanAmt:622000, purpose:"Purchase", type:"Conv 30yr", action:"Originated", denial: null,                                       tract:"2018.02", lmi:false, flag: null },
  { id:"LAR-005", applicant:"Garcia, R",         race:"Hispanic/Latino",         gender:"Male",   age:52, income:88000,  loanAmt:418000, purpose:"Refi",     type:"VA 30yr",   action:"Originated", denial: null,                                       tract:"2014.03", lmi:true,  flag: null },
  { id:"LAR-006", applicant:"Chen, L & M",       race:"Asian",                   gender:"Male",   age:39, income:312000, loanAmt:920000, purpose:"Purchase", type:"Jumbo 30yr",action:"Originated", denial: null,                                       tract:"2022.01", lmi:false, flag: null },
  { id:"LAR-007", applicant:"Williams, T",       race:"Black/African American",  gender:"Female", age:31, income:54000,  loanAmt:285000, purpose:"Purchase", type:"FHA 30yr",  action:"Denied",     denial:"DTI 48% exceeds guideline; insufficient reserves", tract:"2011.01", lmi:true, flag:"ERROR: Denial must use 3-reason format per Reg C — correction required" },
  { id:"LAR-008", applicant:"Nguyen, P & Q",     race:"Asian",                   gender:"Male",   age:44, income:156000, loanAmt:510000, purpose:"Refi",     type:"Conv 30yr", action:"Originated", denial: null,                                       tract:"2016.04", lmi:false, flag: null },
  { id:"LAR-009", applicant:"Martinez, F",       race:"Hispanic/Latino",         gender:"Male",   age:58, income:72000,  loanAmt:228000, purpose:"Purchase", type:"FHA 30yr",  action:"Denied",     denial:"Insufficient credit history; DTI 42%",      tract:"2019.07", lmi:true,  flag: null },
  { id:"LAR-010", applicant:"Johnson, B",        race:"White",                   gender:"Female", age:35, income:142000, loanAmt:398000, purpose:"Purchase", type:"Conv 30yr", action:"Originated", denial: null,                                       tract:"2020.01", lmi:false, flag: null },
  { id:"LAR-011", applicant:"Thompson, R",       race:"White",                   gender:"Male",   age:47, income:188000, loanAmt:562000, purpose:"Refi",     type:"Conv 30yr", action:"Withdrawn",  denial: null,                                       tract:"2021.02", lmi:false, flag: null },
  { id:"LAR-012", applicant:"Singh, A",          race:"Asian",                   gender:"Male",   age:33, income:168000, loanAmt:445000, purpose:"Purchase", type:"Conv 30yr", action:"Originated", denial: null,                                       tract:"2017.03", lmi:false, flag: null },
];

// ── FAIR LENDING ANALYTICS ────────────────────────────────────────
export const FAIR_LENDING_DATA = {
  reportPeriod: "Q1 2026 (Jan 1 — Mar 2)",
  totalApplications: 334,
  denialRates: [
    { group: "White",                  apps: 142, originated: 128, denied:  9, withdrawn: 5, denialRate: 0.0634, peerMedian: 0.0712, disparity: -0.0078, disparityFlag: false  },
    { group: "Hispanic / Latino",      apps:  84, originated:  68, denied: 12, withdrawn: 4, denialRate: 0.1429, peerMedian: 0.1186, disparity:  0.0243, disparityFlag: true   },
    { group: "Black / African Amer.",  apps:  38, originated:  26, denied: 10, withdrawn: 2, denialRate: 0.2632, peerMedian: 0.1842, disparity:  0.0790, disparityFlag: true   },
    { group: "Asian",                  apps:  62, originated:  57, denied:  3, withdrawn: 2, denialRate: 0.0484, peerMedian: 0.0612, disparity: -0.0128, disparityFlag: false  },
    { group: "Native American",        apps:   8, originated:   5, denied:  2, withdrawn: 1, denialRate: 0.2500, peerMedian: 0.2100, disparity:  0.0400, disparityFlag: true   },
  ],
  pricingDisparity: [
    { group: "White",                 avgRate: 6.72, peerAvg: 6.74, spread: -0.02, flag: false },
    { group: "Hispanic / Latino",     avgRate: 6.94, peerAvg: 6.81, spread:  0.13, flag: true  },
    { group: "Black / African Amer.", avgRate: 7.12, peerAvg: 6.98, spread:  0.14, flag: true  },
    { group: "Asian",                 avgRate: 6.68, peerAvg: 6.71, spread: -0.03, flag: false },
    { group: "Native American",       avgRate: 7.08, peerAvg: 6.95, spread:  0.13, flag: true  },
  ],
  lmiTracking: { lmiLoans: 28, lmiGoal: 35, lmiPct: 0.184, goalPct: 0.230, lmiVolume: 8420000, totalVolume: 45800000 },
  examFindings: [
    { severity: "finding", regulation: "HMDA Reg C",    finding: "Williams denial (LAR-007) coded with 1 reason — Reg C requires 3-reason format" },
    { severity: "monitor", regulation: "ECOA / FHA",    finding: "Black/African American denial rate 26.3% — 7.9pp above peer median" },
    { severity: "monitor", regulation: "ECOA",          finding: "Hispanic/Latino avg rate 13bps above peer — pricing disparity detected" },
    { severity: "watch",   regulation: "CRA Reg BB",    finding: "LMI lending at 18.4% vs 23.0% goal — 4.6pp gap to CRA lending test target" },
  ],
};

// ── INTEREST RATE DERIVATIVES ─────────────────────────────────────
export const DERIVATIVES_BOOK = {
  totalNotional:    150000000,
  netFairValue:      -2840000,
  hedgeEffectiveness: 0.94,
  swaps: [
    { id:"SW-001", type:"Pay Fixed / Receive Float", notional:  75000000, payRate: 3.85, receiveIndex:"SOFR+26bps", currentReceive: 5.48, maturity:"Jun 15, 2028",  fairValue: -1240000, hedgeType:"Cash Flow",   counterparty:"JPMorgan Chase",  effectiveness: 0.97, status:"Active"   },
    { id:"SW-002", type:"Pay Fixed / Receive Float", notional:  50000000, payRate: 4.12, receiveIndex:"SOFR+26bps", currentReceive: 5.48, maturity:"Dec 20, 2027",  fairValue:  -980000, hedgeType:"Cash Flow",   counterparty:"Wells Fargo",     effectiveness: 0.94, status:"Active"   },
    { id:"SW-003", type:"Pay Float / Receive Fixed", notional:  25000000, payRate: 5.48, receiveIndex:"4.50% Fixed",currentReceive: 4.50, maturity:"Mar 31, 2026",  fairValue:  -620000, hedgeType:"Fair Value",  counterparty:"Bank of America", effectiveness: 0.91, status:"Maturing" },
  ],
  vaR: { oneDay: 142000, tenDay: 449000, confidence: 0.99 },
  collateral: { posted: 3200000, threshold: 5000000, availableCapacity: 1800000 },
  asc815: {
    lastValidation: "Sep 28, 2025",
    validator: "KPMG Risk Advisory",
    nextValidation: "Sep 30, 2026",
    modelTier: "Tier 2 — High",
    limitations: "Assumes parallel yield curve shifts; non-parallel scenarios reduce effectiveness estimates",
  },
};

// ── INTRADAY CASH POSITION ────────────────────────────────────────
export const INTRADAY_POSITION = {
  asOf: "March 2, 2026 — 2:14 PM PST",
  fedBalance: 184200000,
  targetBalance: 50000000,
  surplus: 134200000,
  fedFundsRate: 0.0530,
  overnightIncome: 19500, // daily surplus × rate / 365
  dayLightOverdraftLimit: 50000000,
  dayLightOverdraftUsed: 0,
  projectedEOD: 162400000,
  activity: [
    { time:"6:00 AM",  type:"Opening Balance",          inflow:       0, outflow:        0, balance: 168400000, cat:"Opening"   },
    { time:"7:42 AM",  type:"FedWire Received",         inflow:24200000, outflow:        0, balance: 192600000, cat:"Wire"      },
    { time:"8:15 AM",  type:"ACH Morning Settlement",   inflow: 8400000, outflow: 12800000, balance: 188200000, cat:"ACH"       },
    { time:"9:30 AM",  type:"FHLB Advance Repayment",   inflow:       0, outflow: 40000000, balance: 148200000, cat:"Funding"   },
    { time:"10:42 AM", type:"⚠ OFAC Wire HELD",         inflow:       0, outflow:        0, balance: 148200000, cat:"Exception" },
    { time:"11:15 AM", type:"FedWire Received",         inflow:18600000, outflow:        0, balance: 166800000, cat:"Wire"      },
    { time:"12:00 PM", type:"Check Clearing Batch",     inflow: 2800000, outflow: 14200000, balance: 155400000, cat:"Checks"    },
    { time:"1:30 PM",  type:"FedWire Sent",             inflow:       0, outflow:  8400000, balance: 147000000, cat:"Wire"      },
    { time:"2:14 PM",  type:"Current Position",         inflow:37200000, outflow:        0, balance: 184200000, cat:"Current"   },
  ],
  pendingWires: [
    { id:"W-0302-14", customer:"Metro Motors Group",      amount:  8400000, dir:"Out", status:"Pending OFAC", eta:"3:00 PM" },
    { id:"W-0302-15", customer:"Regional Ag Cooperative",amount:  2100000, dir:"In",  status:"In Transit",   eta:"3:30 PM" },
    { id:"W-0302-16", customer:"County School District", amount: 14200000, dir:"In",  status:"Confirmed",    eta:"4:00 PM" },
  ],
};

// ── MODEL GOVERNANCE REGISTRY ─────────────────────────────────────
export const MODEL_GOVERNANCE = [
  { id:"MOD-001", name:"CECL ACL Model",               owner:"D. Norris",   vendor:"Moody's Analytics", type:"Credit Risk",     lastVal:"Aug 14, 2025", validator:"Protiviti",      nextVal:"Aug 31, 2026",        status:"Validated",    tier:"Tier 1",  matScore: 82, ref:"FASB ASC 326 · FDIC FIL-22-2022",        limitation:"Assumes stable macro; GDP shock >4pp requires manual overlay" },
  { id:"MOD-002", name:"ALM / NII Sensitivity",        owner:"P. Rivers",   vendor:"Bancware (FIS)",    type:"Interest Rate",   lastVal:"Jul 22, 2025", validator:"KPMG",           nextVal:"Jul 31, 2026",        status:"Validated",    tier:"Tier 1",  matScore: 88, ref:"FRB SR 10-6 · FDIC FIL-02-2012",         limitation:"Parallel shift assumption; basis risk modeled separately" },
  { id:"MOD-003", name:"Derivatives Hedge Effect.",    owner:"P. Rivers",   vendor:"KPMG Risk Advisory",type:"Market Risk",     lastVal:"Sep 28, 2025", validator:"KPMG",           nextVal:"Sep 30, 2026",        status:"Validated",    tier:"Tier 2",  matScore: 79, ref:"FASB ASC 815 · OCC MRA Guidance",         limitation:"ASC 815 long-haul method — quarterly effectiveness testing required" },
  { id:"MOD-004", name:"Credit Migration / Scoring",  owner:"D. Norris",   vendor:"AFS / Internal",    type:"Credit Risk",     lastVal:"Mar 15, 2025", validator:"Internal Audit", nextVal:"Mar 31, 2026 — DUE",  status:"Due",          tier:"Tier 2",  matScore: 68, ref:"OCC 2011-12 · FDIC Supervisory Guidance",  limitation:"Trained on 2018–2023 data; ag cycle variables require manual override" },
  { id:"MOD-005", name:"Liquidity Stress Model",      owner:"P. Rivers",   vendor:"Bancware (FIS)",    type:"Liquidity",       lastVal:"Nov 10, 2025", validator:"Internal Audit", nextVal:"Nov 30, 2026",        status:"Validated",    tier:"Tier 1",  matScore: 84, ref:"FDIC FIL-13-2023 · Basel III LCR",        limitation:"Correlated exit calibrated to 2023 SVB stress; may understate tail risk" },
  { id:"MOD-006", name:"Deposit Profitability",       owner:"L. Owens",    vendor:"Internal / FIS",    type:"Profitability",   lastVal:"Jan 14, 2025", validator:"Internal Audit", nextVal:"Dec 31, 2025 — OVERDUE",status:"Overdue",    tier:"Tier 2",  matScore: 61, ref:"OCC 2011-12 Model Risk Guidance",          limitation:"Transfer pricing not updated since 2022 rate cycle; ECR may understate" },
];

// ── VENDOR RISK REGISTRY ──────────────────────────────────────────
export const VENDOR_REGISTRY = [
  { id:"VR-001", vendor:"FIS (Fiserv)",          service:"Core Banking — Horizon",     tier:"Tier 1", contract:"Dec 31, 2028", spend:1840000, bcpTested:"Sep 2025", soc2:"Type II — Current", riskScore: 62, concentration:"CRITICAL — single core", issues:"Sole-source core dependency; FDIC examiners flagging concentration risk"     },
  { id:"VR-002", vendor:"Verafin (Nasdaq)",       service:"BSA/AML Monitoring",        tier:"Tier 1", contract:"Jun 30, 2027", spend: 284000, bcpTested:"Sep 2025", soc2:"Type II — Current", riskScore: 78, concentration:"Medium",               issues: null                                                                          },
  { id:"VR-003", vendor:"Bancware (FIS)",         service:"ALM / Liquidity Modeling",  tier:"Tier 1", contract:"Dec 31, 2026", spend: 210000, bcpTested:"Not Tested",soc2:"Type II — Current", riskScore: 54, concentration:"Medium",               issues:"BCP not independently tested; contract renewal Dec 2026 — negotiation needed" },
  { id:"VR-004", vendor:"Salesforce (FSC)",       service:"CRM — Fin. Services Cloud", tier:"Tier 2", contract:"Jan 31, 2027", spend: 168000, bcpTested:"Vendor SLA",soc2:"Type II — Current", riskScore: 82, concentration:"Low",                  issues: null                                                                          },
  { id:"VR-005", vendor:"Amazon AWS",             service:"Cloud — Non-Core Apps",     tier:"Tier 2", contract:"Month-to-Month",spend:142000, bcpTested:"Multi-AZ",  soc2:"Type II — Current", riskScore: 71, concentration:"Low",                  issues:"No formal contract — month-to-month creates continuity risk"                  },
  { id:"VR-006", vendor:"Jack Henry (Symitar)",   service:"Item Processing / Imaging", tier:"Tier 2", contract:"Sep 30, 2027", spend: 124000, bcpTested:"Sep 2025", soc2:"Type II — Current", riskScore: 80, concentration:"Low",                  issues: null                                                                          },
  { id:"VR-007", vendor:"Cornerstone OnDemand",  service:"LMS / HR Training",         tier:"Tier 3", contract:"Mar 31, 2027", spend:  68000, bcpTested:"Vendor SLA",soc2:"Type I Only",       riskScore: 72, concentration:"Low",                  issues:"SOC 2 Type I only — request Type II at next renewal"                          },
  { id:"VR-008", vendor:"ICE / Encompass",        service:"Mortgage LOS",              tier:"Tier 2", contract:"Jun 30, 2028", spend:  98000, bcpTested:"Vendor SLA",soc2:"Type II — Current", riskScore: 84, concentration:"Low",                  issues: null                                                                          },
];

// ── LOAN PRICING ASSUMPTIONS ─────────────────────────────────────
export const LOAN_PRICING_ASSUMPTIONS = {
  costOfFunds:    0.0194,
  servicing:      0.0025,
  origCost:       0.0010,
  targetROE:      0.1200,
  capitalCharge:  0.0080,
  loanTypes: [
    { type:"CRE — Owner Occupied",    riskPremium:0.0100, competFloor:6.25, maxLTV:0.75, maxDSCR:1.20 },
    { type:"CRE — Non-Owner",         riskPremium:0.0150, competFloor:6.50, maxLTV:0.70, maxDSCR:1.25 },
    { type:"C&I — Inv. Grade",        riskPremium:0.0080, competFloor:6.75, maxLTV:null, maxDSCR:null  },
    { type:"C&I — Standard",          riskPremium:0.0120, competFloor:7.25, maxLTV:null, maxDSCR:null  },
    { type:"SBA 7(a)",                riskPremium:0.0060, competFloor:7.50, maxLTV:null, maxDSCR:null  },
    { type:"Agricultural LOC",        riskPremium:0.0180, competFloor:7.75, maxLTV:0.65, maxDSCR:null  },
    { type:"Residential 30yr",        riskPremium:0.0040, competFloor:6.75, maxLTV:0.97, maxDSCR:null  },
    { type:"Equipment",               riskPremium:0.0130, competFloor:7.50, maxLTV:0.80, maxDSCR:null  },
    { type:"HELOC",                   riskPremium:0.0120, competFloor:8.25, maxLTV:0.85, maxDSCR:null  },
    { type:"Consumer Unsecured",      riskPremium:0.0280, competFloor:10.5, maxLTV:null, maxDSCR:null  },
  ],
};

// ── PERSONAS ──────────────────────────────────────────────────────
export const PERSONAS = [
  { id: "ceo",        label: "CEO",        full: "Chief Executive Officer",   name: "Jamie Wright",     initials: "JW", icon: "👔", color: "#7B1C2E", grad: "linear-gradient(135deg,#5C1220,#7B1C2E)" },
  { id: "cfo",        label: "CFO",        full: "Chief Financial Officer",   name: "Lynn Owens",       initials: "LO", icon: "📊", color: "#8B4A2A", grad: "linear-gradient(135deg,#6B3420,#8B4A2A)" },
  { id: "cro",        label: "CRO/ALCO",   full: "Chief Risk Officer",        name: "Pat Rivers",       initials: "PR", icon: "🏛️", color: "#1E3A5F", grad: "linear-gradient(135deg,#142840,#1E3A5F)" },
  { id: "banker",     label: "Banker",     full: "Relationship Manager",      name: "Jordan Reed",      initials: "JR", icon: "🤝", color: "#2C5F3F", grad: "linear-gradient(135deg,#1E4230,#2C5F3F)" },
  { id: "lending",    label: "Lending",    full: "Lending Officer / Manager", name: "Mike Torres",      initials: "MT", icon: "📝", color: "#2C5F6A", grad: "linear-gradient(135deg,#1E4250,#2C5F6A)" },
  { id: "mortgage",   label: "Mortgage",   full: "Mortgage & Consumer Lender",name: "Robin Knox",       initials: "RK", icon: "🏠", color: "#6B3D8A", grad: "linear-gradient(135deg,#4D2864,#6B3D8A)" },
  { id: "wealth",     label: "Wealth",     full: "Wealth & Trust Officer",    name: "Sam Cole",         initials: "SC", icon: "💎", color: "#2C6B5F", grad: "linear-gradient(135deg,#1E4840,#2C6B5F)" },
  { id: "branch",     label: "Branch Mgr", full: "Branch Manager",            name: "Lee Todd",         initials: "LT", icon: "🏢", color: "#7A4F1D", grad: "linear-gradient(135deg,#5A3812,#7A4F1D)" },
  { id: "ops",        label: "Operations", full: "Operations Officer",        name: "Sam Morton",       initials: "SM", icon: "⚙️", color: "#4A3728", grad: "linear-gradient(135deg,#352820,#4A3728)" },
  { id: "compliance", label: "Compliance", full: "BSA / Compliance Officer",  name: "Kelly Ford",       initials: "KF", icon: "🛡️", color: "#7B1C2E", grad: "linear-gradient(135deg,#5C1220,#7B1C2E)" },
  { id: "credit",     label: "Credit",     full: "Chief Credit Officer",      name: "Dan Norris",       initials: "DN", icon: "📋", color: "#2C5F3F", grad: "linear-gradient(135deg,#1E4230,#2C5F3F)" },
];

// ── NAVIGATION TABS ───────────────────────────────────────────────
export const NAV_TABS: Record<string, { id: string; label: string; icon: string }[]> = {
  ceo:        [{ id:"dashboard",label:"Dashboard",icon:"🏠"},{id:"tasks",label:"Tasks",icon:"✅"},{id:"peers",label:"Peer Benchmarks",icon:"📊"},{id:"exam",label:"Exam Readiness",icon:"🛡️"},{id:"board",label:"Board Packages",icon:"📋"},{id:"audit",label:"Audit Trail",icon:"🔍"}],
  cfo:        [{ id:"dashboard",label:"Dashboard",icon:"🏠"},{id:"depoprofit",label:"Deposit Profitability",icon:"💰"},{id:"cashposition",label:"Cash Position",icon:"🏦"},{id:"modelgov",label:"Model Governance",icon:"🧮"},{id:"tasks",label:"Tasks",icon:"✅"},{id:"scenario",label:"Scenarios",icon:"🔮"},{id:"exam",label:"Exam Readiness",icon:"🛡️"},{id:"board",label:"Board Packages",icon:"📋"},{id:"audit",label:"Audit Trail",icon:"🔍"}],
  cro:        [{ id:"dashboard",label:"Dashboard",icon:"🏠"},{id:"alco",label:"ALCO Tools",icon:"📉"},{id:"derivatives",label:"Derivatives",icon:"🔄"},{id:"cashposition",label:"Cash Position",icon:"🏦"},{id:"modelgov",label:"Model Governance",icon:"🧮"},{id:"scenario",label:"Scenarios",icon:"🔮"},{id:"tasks",label:"Tasks",icon:"✅"},{id:"board",label:"Board Packages",icon:"📋"},{id:"audit",label:"Audit Trail",icon:"🔍"}],
  banker:     [{ id:"dashboard",label:"Dashboard",icon:"🏠"},{id:"book",label:"Book of Business",icon:"📒"},{id:"depoprofit",label:"Deposit Profitability",icon:"💰"},{id:"tasks",label:"Tasks",icon:"✅"},{id:"board",label:"Documents",icon:"📋"},{id:"audit",label:"Audit Trail",icon:"🔍"}],
  lending:    [{ id:"dashboard",label:"Dashboard",icon:"🏠"},{id:"pipeline",label:"Loan Pipeline",icon:"📝"},{id:"loanpricing",label:"Loan Pricing",icon:"🧮"},{id:"watchlist",label:"Watchlist",icon:"⚠️"},{id:"tasks",label:"Tasks",icon:"✅"},{id:"peers",label:"Peer Benchmarks",icon:"📊"},{id:"board",label:"Documents",icon:"📋"},{id:"audit",label:"Audit Trail",icon:"🔍"}],
  mortgage:   [{ id:"dashboard",label:"Dashboard",icon:"🏠"},{id:"mortpipeline",label:"Mortgage Pipeline",icon:"🏠"},{id:"hmdalar",label:"HMDA LAR",icon:"📋"},{id:"fairlending",label:"Fair Lending",icon:"⚖️"},{id:"tasks",label:"Tasks",icon:"✅"},{id:"board",label:"Documents",icon:"📋"},{id:"audit",label:"Audit Trail",icon:"🔍"}],
  wealth:     [{ id:"dashboard",label:"Dashboard",icon:"🏠"},{id:"wealthaccounts",label:"Accounts",icon:"💎"},{id:"tasks",label:"Tasks",icon:"✅"},{id:"board",label:"Documents",icon:"📋"},{id:"audit",label:"Audit Trail",icon:"🔍"}],
  branch:     [{ id:"dashboard",label:"Dashboard",icon:"🏠"},{id:"branchdetail",label:"Branch Detail",icon:"🏢"},{id:"tasks",label:"Tasks",icon:"✅"},{id:"board",label:"Documents",icon:"📋"},{id:"audit",label:"Audit Trail",icon:"🔍"}],
  ops:        [{ id:"dashboard",label:"Dashboard",icon:"🏠"},{id:"exceptions",label:"Exceptions",icon:"⚠️"},{id:"fraud",label:"Fraud Queue",icon:"🚨"},{id:"ittickets",label:"IT Tickets",icon:"💻"},{id:"bcp",label:"BCP / DR",icon:"🛡️"},{id:"vendors",label:"Vendor Risk",icon:"🏗️"},{id:"cashposition",label:"Cash Position",icon:"🏦"},{id:"tasks",label:"Tasks",icon:"✅"},{id:"board",label:"Documents",icon:"📋"},{id:"audit",label:"Audit Trail",icon:"🔍"}],
  compliance: [{ id:"dashboard",label:"Dashboard",icon:"🏠"},{id:"hmdalar",label:"HMDA LAR",icon:"📋"},{id:"fairlending",label:"Fair Lending",icon:"⚖️"},{id:"exam",label:"Exam Readiness",icon:"🛡️"},{id:"tasks",label:"Tasks",icon:"✅"},{id:"board",label:"Documents",icon:"📋"},{id:"audit",label:"Audit Trail",icon:"🔍"}],
  credit:     [{ id:"dashboard",label:"Dashboard",icon:"🏠"},{id:"watchlist",label:"Watchlist",icon:"⚠️"},{id:"loanfiles",label:"Loan Files",icon:"📂"},{id:"tasks",label:"Tasks",icon:"✅"},{id:"peers",label:"Peer Benchmarks",icon:"📊"},{id:"scenario",label:"Scenarios",icon:"🔮"},{id:"exam",label:"Exam Readiness",icon:"🛡️"},{id:"board",label:"Documents",icon:"📋"},{id:"audit",label:"Audit Trail",icon:"🔍"}],
};
